<template>
  <p>1. O DRAPH</p>
  <p>
    Draph Solutions sro je společnost založen&aacute; v Česk&eacute; republice (d&aacute;le jen
    &bdquo;CZ&ldquo;) se zapsan&yacute;m č&iacute;slem C 278807, se s&iacute;dlem Národní 961/25,
    Staré Město, 110 00 Praha 1 (d&aacute;le jen &bdquo; Draph &ldquo;, &bdquo;my&ldquo; nebo
    &bdquo;n&aacute;s&ldquo;).
  </p>
  <p>
    Nab&iacute;z&iacute;me platebn&iacute; služby jako poskytovatel platebn&iacute;ch služeb
    mal&eacute;ho rozsahu (d&aacute;le jen &bdquo;SSP&ldquo;) a nenab&iacute;z&iacute;me
    bankovn&iacute; služby.
  </p>
  <p>
    Jsme autorizov&aacute;ni a regulov&aacute;ni Českou n&aacute;rodn&iacute; bankou (d&aacute;le
    jen &bdquo;ČNB&ldquo;).
  </p>
  <p>
    Jsme uzn&aacute;v&aacute;ni a poskytujeme sv&eacute; služby pod obchodn&iacute;m n&aacute;zvem '
    Swipez '.
  </p>
  <p>
    NEPOSKYTUJEME Ž&Aacute;DN&Aacute; FINANČN&Iacute;, INVESTIČN&Iacute;, PR&Aacute;VN&Iacute; ČI
    JIN&Eacute; RADY T&Yacute;KAJ&Iacute;C&Iacute; SE SPR&Aacute;VY A VYUŽ&Iacute;V&Aacute;N&Iacute;
    PROSTŘEDKŮ KLIENTA A NEPOSKYTUJEME V&Aacute;M POSOUZEN&Iacute; MOŽN&Yacute;CH RIZIK PŘI
    POUŽ&Iacute;V&Aacute;N&Iacute; SLUŽEB. S KLIENTEM MŮŽEME KONZULTOVAT POUZE
    T&Yacute;KAJ&Iacute;C&Iacute; SE USTANOVEN&Iacute; PODM&Iacute;NEK SLUŽEB, KTER&Eacute; KLIENT
    ZAMĚŘUJE POUŽ&Iacute;VAT NEBO JIŽ POUŽ&Iacute;V&Aacute;, POUŽ&Iacute;V&Aacute;N&Iacute;
    SYST&Eacute;MU A TECHNICK&Eacute; MOŽNOSTI, TAK&Eacute; T&Yacute;KAJ&Iacute;C&Iacute; SE
    ZPRACOV&Aacute;N&Iacute; A OCHRANY OSOBN&Iacute;CH &Uacute;DAJŮ KLIENTŮ,
    ZPRACOV&Aacute;N&Iacute; A OCHRANY SPOTŘEBITŮ BTEC Z&Aacute;KONY A PŘEDPISY V PŘ&Iacute;PADĚ
    REKLAMACE A SPORŮ. KLIENT PŘED VSTUPEM DO OBCHODN&Iacute;HO VZTAHU A ZAH&Aacute;JEN&Iacute;M
    POUŽ&Iacute;V&Aacute;N&Iacute; SLUŽEB POSOUZ&Iacute; MOŽN&Aacute; RIZIKA A SVŮJ SPOKOJENOST SE
    SLUŽBAMI, KTER&Eacute; BUDE UŽ&Iacute;VAT.
  </p>
  <p>
    Ž&Aacute;DN&Yacute;M ZPŮSOBEM NEBUDEME ZASAHOVAT DO PR&Aacute;VN&Iacute;CH A OBCHODN&Iacute;CH
    VZTAHŮ A JAK&Yacute;CHKOLI SPORU VZNIKNUT&Yacute;CH MEZI PŘ&Iacute;JEMcem A KLIENTEM,
    POSKYTOVATELEM PLATEBN&Iacute;CH SLUŽEB/PLATEBN&Iacute; INSTITUC&Iacute;. JE NA KLIENTOVI, ABY
    Z&Iacute;SKAL V&Scaron;ECHNY UŽITEČN&Eacute; INFORMACE PŘED N&Aacute;KUPEM PRODUKTU NEBO SLUŽBY,
    V&Yacute;BĚREM PROSTŘEDKŮ NEBO JAK&Eacute;KOLI JIN&Eacute; TRANSAKCI, PŘI PLN&Eacute;M
    ZN&Aacute;M&Iacute; V&Scaron;ECH SOUVISEJ&Iacute;C&Iacute;CH &Uacute;VAHY. Z JAK&Eacute;KOLI
    TRANSAKCE PROVEDEN&Eacute; KLIENTEM VZNIK&Aacute; SMLOUVA UZAVŘEN&Aacute; PŘ&Iacute;MO MEZI
    KLIENTEM A TŘET&Iacute; STRANOU, S N&Iacute;Ž DRAPH NEM&Aacute; Ž&Aacute;DN&Yacute; VZTAH NEBO
    Z&Aacute;VAZKY. DRAPH NEMŮŽE ZA Ž&Aacute;DN&Yacute;CH OKOLNOST&Iacute; B&Yacute;T
    ODPOVĚDN&Yacute; ZA NEPLNĚN&Iacute; NEBO &Scaron;PATN&Eacute; PLNĚN&Iacute; Z&Aacute;VAZKŮ,
    KTER&Eacute; MOHOU D&Iacute;T, NEBO PŘ&Iacute;PADN&Eacute; &Scaron;KODY ZPŮSOBEN&Eacute;
    KLIENTOVI V TOMTO OHLEDU.
  </p>
  <p>
    BERETE NA VĚDOM&Iacute; A SOUHLAS&Iacute;TE S T&Iacute;M, ŽE DRAPH NEBUDE ODPOVĚDN&Yacute; ZA
    Ž&Aacute;DN&Eacute; ZTR&Aacute;TY NEBO &Scaron;KODY, KTER&Eacute; Utrp&iacute;te V SOUVISLOSTI S
    POUŽ&Iacute;V&Aacute;N&Iacute;M SLUŽEB, KDE BY TAKOV&Aacute; ZTR&Aacute;TA NEBO &Scaron;KODA
    ZPŮSOBILA VA&Scaron;&Iacute;M ČINEM NEBO Opomenut&iacute;m THITY NEBO THITY.
  </p>
  <p>
    POKUD DRAPH NEBUDE SPLŇOVAT PODM&Iacute;NKY, JAK&Yacute;KOLI DODATEK NEBO JAK&Eacute;KOLI
    DOKUMENTY, NA KTER&Eacute; V NĚCH ODKAZUJEME, BUDEME ODPOVĚDN&Iacute; ZA JAK&Eacute;KOLI
    PŘ&Iacute;M&Eacute; ZTR&Aacute;TY NEBO &Scaron;KODY, KTER&Eacute; Utrp&iacute;te, COŽ JE
    PŘEDPOKLADATELN&Yacute;M V&Yacute;SLEDKEM PORU&Scaron;EN&Iacute; DRAPH JEJICH NEBEZPEČ&Iacute;
    PŘIMĚŘEN&Aacute; P&Eacute;ČE A DOVEDNOST PŘI POSKYTOV&Aacute;N&Iacute; SV&Yacute;CH SLUŽEB ZA
    PODM&Iacute;NEK, JAK&Eacute;HOKOLI DODATKU NEBO JAK&Eacute;HOKOLI DOKUMENTU, NA KTER&Yacute; V
    NĚM ODKAZUJEME, ALE DRAPH NEODPOV&Iacute;D&Aacute; ZA Ž&Aacute;DN&Eacute; ZTR&Aacute;TY ČI
    &Scaron;KODY, KTER&Eacute; NEN&Iacute; PŘEDV&Iacute;DAJ&Iacute;C&Iacute; NEBO KTER&Eacute;
    NEN&Iacute; MOŽN&Eacute;.
  </p>
  <p>
    DRAPH V MAXIM&Aacute;LN&Iacute;M ROZSAHU POVOLEN&Eacute;M PLATN&Yacute;M Z&Aacute;KONEM NENESE
    ODPOVĚDNOST ZA Ž&Aacute;DN&Eacute; ZTR&Aacute;TY ZISKU, ZTR&Aacute;TU PODNIK&Aacute;N&Iacute;,
    PŘERU&Scaron;EN&Iacute; OBCHODN&Iacute; ČINNOSTI NEBO ZTR&Aacute;TU OBCHODN&Iacute;
    PŘ&Iacute;LEŽITOSTI, STEJNĚ NEBUDE ODPOVĚDN&Aacute; ZA Ž&Aacute;DN&Eacute; NEJEDNOTLIV&Eacute;,
    NEJEDNOTLIV&Eacute;, NEJEDNOTLIV&Eacute; &Scaron;KODY VZNIKL&Eacute; Z OBCHODN&Iacute;HO VZTAHU
    NEBO V SOUVISLOSTI S NĚM.
  </p>
  <p>2. ROZSAH PODM&Iacute;NEK</p>
  <p>
    Tyto Podm&iacute;nky služby (d&aacute;le jen &bdquo;Podm&iacute;nky&ldquo;) a každ&yacute; z
    dokumentů, na kter&eacute; v nich odkazujeme, jsou na&scaron;&iacute; standardn&iacute;
    klientskou smlouvou, kter&aacute; vytv&aacute;ř&iacute; pr&aacute;vně z&aacute;vaznou smlouvu
    mezi klientem a Draph t&yacute;kaj&iacute;c&iacute; se poskytov&aacute;n&iacute;
    platebn&iacute;ch služeb.
  </p>
  <p>
    Tyto Podm&iacute;nky jsou připraveny a budou se ř&iacute;dit a vykl&aacute;dat v souladu se
    z&aacute;kony Česk&eacute; republiky. Tyto Podm&iacute;nky stanovuj&iacute;
    z&aacute;kladn&iacute; pr&aacute;va a povinnosti obchodn&iacute;ho vztahu založen&eacute;ho mezi
    Draph a jeho klienty.
  </p>
  <p>
    Tyto Podm&iacute;nky stanovuj&iacute; podm&iacute;nky, za kter&yacute;ch poskytujeme
    na&scaron;im klientům platebn&iacute; služby, a tak&eacute; podm&iacute;nky, za kter&yacute;ch
    je &uacute;čet zř&iacute;zen a veden.
  </p>
  <p>
    T&iacute;mto v&aacute;s informujeme, že va&scaron;e finančn&iacute; prostředky držen&eacute; u
    Draph nejsou poji&scaron;těny a chr&aacute;něny česk&yacute;mi vl&aacute;dn&iacute;mi
    kompenzačn&iacute;mi syst&eacute;my na pokryt&iacute; ztr&aacute;t n&aacute;rokovan&yacute;ch v
    souvislosti s poskytovan&yacute;mi službami a prostředky na &uacute;čtech. Přesto
    zaji&scaron;ťujeme, aby va&scaron;e prostředky držen&eacute; u n&aacute;s byly kryty a
    chr&aacute;něny vhodn&yacute;mi a bezpečn&yacute;mi intern&iacute;mi zabezpečovac&iacute;mi
    postupy stanoven&yacute;mi N&aacute;vrhem a byly zabezpečeny v souladu s požadavky směrnice
    Evropsk&eacute;ho parlamentu a Rady 2015/2366 ze dne 25. listopadu 2015. V př&iacute;padě
    na&scaron;&iacute; platebn&iacute; neschopnosti budou prostředky klientů chr&aacute;něny před
    jak&yacute;mikoli pohled&aacute;vkami v&scaron;ech věřitelů , kteř&iacute; jsou na &uacute;čtu
    Draph . Podrobněj&scaron;&iacute; informace o n&aacute;stroj&iacute;ch a metod&aacute;ch,
    kter&eacute; použ&iacute;v&aacute;me k ochraně va&scaron;ich finančn&iacute;ch prostředků, jsou
    uvedeny v prohl&aacute;&scaron;en&iacute; o vyloučen&iacute; odpovědnosti, kter&eacute; je k
    dispozici na webov&yacute;ch str&aacute;nk&aacute;ch.
  </p>
  <p>
    Než je přijmete, doporučujeme v&aacute;m pozorně si přeč&iacute;st tyto Podm&iacute;nky a
    každ&yacute; z dokumentů, na kter&eacute; v nich odkazujeme. Pro svůj vlastn&iacute; prospěch a
    ochranu va&scaron;ich opr&aacute;vněn&yacute;ch z&aacute;jmů si před přijet&iacute;m těchto
    podm&iacute;nek přečtěte n&aacute;vrh , pokud se jak&eacute;koli ustanoven&iacute;
    obsažen&eacute; v tomto dokumentu nebo v někter&eacute;m z dokumentů, na kter&eacute; v nich
    odkazujeme, jev&iacute; jako nejasn&eacute;, pochybn&eacute; nebo nespravedliv&eacute;. Můžete
    n&aacute;s snadno kontaktovat na adrese na&scaron;eho s&iacute;dla uveden&eacute;
    v&yacute;&scaron;e nebo prostřednictv&iacute;m e-mailov&eacute; adresy support@swipez.eu.
  </p>
  <p>
    Pokud jste přistoupili k otevřen&iacute; platebn&iacute;ho &uacute;čtu a registraci v online
    syst&eacute;mu Draph , abyste se stali na&scaron;&iacute;m klientem, m&aacute; se za to, že jste
    si pozorně přečetli Podm&iacute;nky, jak&yacute;koli dodatek k těmto podm&iacute;nk&aacute;m a
    jak&yacute;koli jin&yacute; dokument, na kter&yacute; v nich odkazujeme, a m&aacute; se za to,
    že souhlas&iacute;te s ustanoven&iacute;mi těchto podm&iacute;nek, jak&yacute;mkoli dodatkem k
    těmto podm&iacute;nk&aacute;m a každ&yacute;m z dokumentů, na kter&eacute; se v nich
    odvol&aacute;v&aacute;me, č&iacute;mž potvrzujete, že v&scaron;echna ustanoven&iacute;,
    kter&aacute; jsou zde uvedena, jsou zcela jasn&aacute; a spravedliv&aacute;.
  </p>
  <p>Při použ&iacute;v&aacute;n&iacute; na&scaron;ich služeb se zavazujete:</p>
  <p>
    dodržovat Podm&iacute;nky, jak&eacute;koli jejich dodatky nebo jak&yacute;koli dokument, na
    kter&yacute; v nich odkazujeme, platn&eacute; n&aacute;rodn&iacute; a nadn&aacute;rodn&iacute;
    z&aacute;kony a předpisy, na kter&eacute; odkazujeme,
  </p>
  <p>
    neposkytovat n&aacute;m nepravdiv&eacute;, zav&aacute;děj&iacute;c&iacute; nebo
    nespr&aacute;vn&eacute; informace, neodm&iacute;tat n&aacute;m poskytnout informace a činit
    dal&scaron;&iacute; kroky, kter&eacute; po n&aacute;s důvodně požadujeme,
  </p>
  <p>
    proj&iacute;t v&scaron;emi povinn&yacute;mi postupy, kter&eacute; prov&aacute;d&iacute;me za
    &uacute;čelem ověřen&iacute; identity klienta a KYC, předložit v&scaron;echny požadovan&eacute;
    &uacute;daje a informace,
  </p>
  <p>
    n&aacute;s včas informovat o jak&yacute;chkoli změn&aacute;ch dř&iacute;ve předložen&yacute;ch
    informac&iacute;, &uacute;dajů a dokumentů. V př&iacute;padě, že tak neučin&iacute;te, jsme
    zpro&scaron;těni jak&eacute;koli odpovědnosti za spr&aacute;vn&eacute; a přesn&eacute;
    proveden&iacute; platebn&iacute; transakce a vy ponesete plnou odpovědnost a ponesete
    ve&scaron;ker&eacute; ztr&aacute;ty, a to i ve vztahu k jak&eacute;koli třet&iacute; straně, ke
    kter&yacute;m může doj&iacute;t v důsledku předložen&iacute; neplatn&yacute;ch &uacute;dajů nebo
    odm&iacute;tnut&iacute; před&aacute;n&iacute; &uacute;dajů. Vyhrazujeme si pr&aacute;vo
    pozastavit poskytov&aacute;n&iacute; služeb, dokud neaktualizujete &uacute;daje a informace,
  </p>
  <p>
    nepouž&iacute;t finančn&iacute; prostředky neleg&aacute;ln&iacute;ho původu na
    poskytovan&eacute; služby,
  </p>
  <p>
    nepouž&iacute;vat služby způsobem, kter&yacute; způsobuje ztr&aacute;ty nebo jin&eacute;
    negativn&iacute; pr&aacute;vn&iacute; nebo finančn&iacute; důsledky nebo po&scaron;kozuje
    obchodn&iacute; stabilitu a pověst společnosti Draph nebo jak&eacute;koli třet&iacute; osoby,
  </p>
  <p>
    ne přihl&aacute;sit se do syst&eacute;mu Koncept jako anonymn&iacute; uživatel (např. přes proxy
    servery) nebo m&iacute;t v syst&eacute;mu v&iacute;ce než jeden profil; nezaregistrovat profil
    pod fiktivn&iacute;m jm&eacute;nem nebo jm&eacute;nem třet&iacute; osoby bez
    př&iacute;slu&scaron;n&eacute;ho pr&aacute;vn&iacute;ho z&aacute;kladu z&aacute;stupce;
    nezaregistrovat si profil pomoc&iacute; služeb anonymn&iacute;ch telefonn&iacute;ch č&iacute;sel
    nebo e-mailov&yacute;ch adres poskytnut&yacute;ch jin&yacute;mi osobami nebo weby,
  </p>
  <p>
    nepouž&iacute;vat &uacute;čet pro služby nebo zbož&iacute;, kter&eacute; jsou
    zak&aacute;z&aacute;ny z&aacute;kony nebo odporuj&iacute; veřejn&eacute;mu poř&aacute;dku a
    mor&aacute;ln&iacute;m z&aacute;sad&aacute;m,
  </p>
  <p>
    vědomě neposkytovat třet&iacute;m stran&aacute;m nepravdiv&eacute;,
    zav&aacute;děj&iacute;c&iacute; nebo nespr&aacute;vn&eacute; informace o n&aacute;s a
    služb&aacute;ch, kter&eacute; poskytujeme,
  </p>
  <p>
    dodržovat a respektovat ochrann&eacute; zn&aacute;mky/obchodn&iacute; n&aacute;zvy,
    autorsk&aacute; pr&aacute;va, obchodn&iacute; tajemstv&iacute; a dal&scaron;&iacute;
    pr&aacute;va du&scaron;evn&iacute;ho vlastnictv&iacute; společnosti Draph a třet&iacute;ch
    stran. Toto ustanoven&iacute; se na v&aacute;s nevztahuje, pokud jste v dobr&eacute; v&iacute;ře
    věděli a nemohli vědět o existenci ochrann&yacute;ch zn&aacute;mek/obchodn&iacute;ch jmen,
    autorsk&yacute;ch pr&aacute;v nebo jin&yacute;ch pr&aacute;v du&scaron;evn&iacute;ho
    vlastnictv&iacute; nebo o tom, že informace představuj&iacute; obchodn&iacute; tajemstv&iacute;,
  </p>
  <p>
    ne&scaron;&iacute;řit poč&iacute;tačov&eacute; viry a neprov&aacute;dět jin&eacute; akce,
    kter&eacute; by mohly způsobit poruchy na&scaron;eho syst&eacute;mu, po&scaron;kozen&iacute;
    nebo zničen&iacute; informac&iacute; a jin&eacute; po&scaron;kozen&iacute; syst&eacute;mu,
    zař&iacute;zen&iacute; Draph nebo informac&iacute;,
  </p>
  <p>
    v pln&eacute; v&yacute;&scaron;i uhradit a ochr&aacute;nit n&aacute;s před jak&yacute;mikoli
    n&aacute;klady a ztr&aacute;tami, kter&eacute; mohou vzniknout, pokud (zcela nebo
    č&aacute;stečně, včetně, ale nejen, opomenut&iacute; nebo zav&aacute;děj&iacute;c&iacute;ho),
    nespln&iacute;te povinnosti podle podm&iacute;nek nebo takov&eacute; n&aacute;klady nebo
    ztr&aacute;ty vznikly v důsledku va&scaron;eho nez&aacute;konn&eacute;ho jedn&aacute;n&iacute;.
  </p>
  <p>3. DEFINICE</p>
  <p>
    &Uacute;čet &ndash; &uacute;čet nebo v&iacute;ceměnov&yacute; &uacute;čet (pokud je k dispozici)
    otevřen&yacute; na jm&eacute;no Klienta a použ&iacute;van&yacute; pro Služby poskytovan&eacute;
    Draph .
  </p>
  <p>Zůstatek na &uacute;čtu - množstv&iacute; prostředků na &Uacute;čtu (&uacute;čtech).</p>
  <p>
    Z&aacute;kon - z&aacute;kon o zpracov&aacute;n&iacute; osobn&iacute;ch &uacute;dajů 2019 (č.
    110/2019 Sb., &bdquo;ZZO&Uacute;&ldquo;).
  </p>
  <p>
    AML/CTF &ndash; boj proti pran&iacute; &scaron;pinav&yacute;ch peněz a financov&aacute;n&iacute;
    terorismu.
  </p>
  <p>App - mobiln&iacute; aplikačn&iacute; software Draph System.</p>
  <p>
    Ž&aacute;dost &ndash; pap&iacute;rov&yacute; nebo on-line &uacute;vodn&iacute; formul&aacute;ř
    pro otevřen&iacute; &Uacute;čtu, kter&yacute; vypln&iacute; Klient nebo jeho Z&aacute;stupce.
  </p>
  <p>
    Podnikatelsk&yacute; &uacute;čet - &uacute;čet zř&iacute;zen&yacute; pro pr&aacute;vnickou nebo
    fyzickou osobu pro jej&iacute; komerčn&iacute; &uacute;čely.
  </p>
  <p>
    Pracovn&iacute; den - jak&yacute;koli kalend&aacute;řn&iacute; den, kromě soboty, neděle a
    st&aacute;tn&iacute;ch sv&aacute;tků v Česk&eacute; republice, kdy jsou platebn&iacute;
    infrastruktury a banky v Česk&eacute; republice otevřeny pro podnik&aacute;n&iacute;, nebo
    jak&yacute;koli jin&yacute; n&aacute;mi definovan&yacute; den a ř&aacute;dně
    ozn&aacute;men&yacute; Klientovi.
  </p>
  <p>
    Provozn&iacute; doba &ndash; provozn&iacute; doba od 09:00 do 17:30 (časov&eacute; p&aacute;smo
    CZ).
  </p>
  <p>
    Obchodn&iacute; vztah - vz&aacute;jemn&yacute; z&aacute;vazn&yacute; vztah mezi Draph a Klientem
    vznikl využ&iacute;v&aacute;n&iacute;m Služeb.
  </p>
  <p>
    Klient (tak&eacute; &bdquo;vy&ldquo;) &ndash; pr&aacute;vnick&aacute; nebo fyzick&aacute; osoba,
    na jej&iacute;ž jm&eacute;no je zř&iacute;zen &Uacute;čet a jsou využ&iacute;v&aacute;ny Služby.
  </p>
  <p>
    Identifikace klienta &ndash; soubor opatřen&iacute; KYC a Due Diligence uplatňovan&yacute;ch
    n&aacute;vrhem k zamezen&iacute; pran&iacute; &scaron;pinav&yacute;ch peněz a
    financov&aacute;n&iacute; terorismu s v&yacute;hradou z&aacute;vazn&yacute;ch požadavků
    př&iacute;slu&scaron;n&yacute;ch předpisů AML/CTF.
  </p>
  <p>
    Poplatky (tak&eacute; poplatky) - poplatky splatn&eacute; Klientem za poskytnut&eacute; Služby
    stanoven&eacute; v Sazebn&iacute;ku. Sazebn&iacute;k poplatků je dostupn&yacute; v
    Syst&eacute;mu.
  </p>
  <p>
    GDPR - Nař&iacute;zen&iacute; Evropsk&eacute;ho parlamentu a Rady (EU) 2016/679 ze dne 27. dubna
    2016 o ochraně fyzick&yacute;ch osob v souvislosti se zpracov&aacute;n&iacute;m osobn&iacute;ch
    &uacute;dajů a o voln&eacute;m pohybu těchto &uacute;dajů a o zru&scaron;en&iacute; směrnice
    95/46/ES (obecn&eacute; nař&iacute;zen&iacute; o ochraně osobn&iacute;ch &uacute;dajů).
  </p>
  <p>
    KYC - Poznejte postupy sv&eacute;ho klienta prov&aacute;děn&eacute; n&aacute;vrhem Draph podle
    povinn&yacute;ch ustanoven&iacute; př&iacute;slu&scaron;n&yacute;ch z&aacute;konů a předpisů v
    oblasti AML/CTF.
  </p>
  <p>Př&iacute;kaz - pokyn Klienta k proveden&iacute; Platebn&iacute; transakce.</p>
  <p>Party nebo Party - vy a my.</p>
  <p>
    Pl&aacute;tce - fyzick&aacute; nebo pr&aacute;vnick&aacute; osoba, kter&aacute;
    prov&aacute;d&iacute; platebn&iacute; př&iacute;kaz z platebn&iacute;ho &uacute;čtu.
  </p>
  <p>
    Platebn&iacute; transakce - převod peněžn&iacute;ch prostředků iniciovan&yacute; Pl&aacute;tcem,
    na jm&eacute;no Pl&aacute;tce nebo Př&iacute;jemcem.
  </p>
  <p>
    Osobn&iacute; &uacute;čet &ndash; &uacute;čet zř&iacute;zen&yacute; pro soukrom&eacute; osoby
    pro nekomerčn&iacute; &uacute;čely.
  </p>
  <p>
    Osobn&iacute; &uacute;daje &ndash; ve&scaron;ker&eacute; informace, kter&eacute; se
    t&yacute;kaj&iacute; identifikovan&eacute; nebo identifikovateln&eacute; soukrom&eacute; osoby,
    tak&eacute; různ&eacute; informace, kter&eacute; shrom&aacute;žděn&eacute; dohromady mohou
    v&eacute;st k identifikaci konkr&eacute;tn&iacute; osoby. Z&aacute;sady zpracov&aacute;n&iacute;
    osobn&iacute;ch &uacute;dajů jsou definov&aacute;ny v N&aacute;vrhu Z&aacute;sad ochrany
    osobn&iacute;ch &uacute;dajů, kter&yacute; je k dispozici na Webu.
  </p>
  <p>
    Z&aacute;sady ochrany osobn&iacute;ch &uacute;dajů &ndash; Navrhněte intern&iacute; pravidla a
    postupy ochrany osobn&iacute;ch &uacute;dajů t&yacute;kaj&iacute;c&iacute; se
    zpracov&aacute;n&iacute; osobn&iacute;ch &uacute;dajů, včetně dal&scaron;&iacute;ho
    před&aacute;v&aacute;n&iacute; a uchov&aacute;v&aacute;n&iacute; osobn&iacute;ch &uacute;dajů,
    stanoven&eacute; na z&aacute;kladě z&aacute;kona a GDPR, jakož i běžn&yacute;ch standardů
    dobr&eacute; praxe.
  </p>
  <p>
    Profil &ndash; Osobn&iacute; panel Klienta v Syst&eacute;mu dostupn&yacute;
    prostřednictv&iacute;m Webov&eacute; str&aacute;nky nebo Aplikace, kde Klient může spravovat
    &Uacute;čty, použ&iacute;vat Služby, zad&aacute;vat Př&iacute;kazy a prov&aacute;dět
    Platebn&iacute; transakce.
  </p>
  <p>
    Př&iacute;jemce - fyzick&aacute; nebo pr&aacute;vnick&aacute; osoba uveden&aacute; v
    Př&iacute;kazu jako př&iacute;jemce peněžn&iacute;ch prostředků Platebn&iacute; transakce.
  </p>
  <p>
    Z&aacute;stupce - osoba ř&aacute;dně zmocněn&aacute; Klientem k zastupov&aacute;n&iacute;
    Klienta ve vztaz&iacute;ch s Draph , už&iacute;v&aacute;n&iacute; Služeb,
    zad&aacute;v&aacute;n&iacute; Př&iacute;kazů a prov&aacute;děn&iacute; Platebn&iacute;ch
    transakc&iacute;, jednaj&iacute;c&iacute; na z&aacute;kladě pln&eacute; moci nebo jin&eacute;ho
    pr&aacute;vn&iacute;ho důvodu.
  </p>
  <p>
    Služby - Platebn&iacute; transakce prov&aacute;děn&eacute; prostřednictv&iacute;m &Uacute;čtu
    (&uacute;čtů).
  </p>
  <p>
    Strong Customer Authentication (SCA) - metoda ověřen&iacute; založen&aacute; na minim&aacute;lně
    dvou prvc&iacute;ch kategorizovan&yacute;ch ve směrnici Evropsk&eacute;ho parlamentu a Rady (EU)
    2015/2366 o platebn&iacute;ch služb&aacute;ch na vnitřn&iacute;m trhu, kterou se měn&iacute;
    směrnice 2002/65/ES, 2009/110/ES a 2013/36/EU a nař&iacute;zen&iacute; č. 2093 a
    nař&iacute;zen&iacute; EU č. 2093 2007/64/ES (25. listopadu 2015).
  </p>
  <p>
    Syst&eacute;m - softwarov&eacute; ře&scaron;en&iacute; použ&iacute;van&eacute; Draphem pro
    veden&iacute; &Uacute;čtů a on-line poskytov&aacute;n&iacute; Služeb. Syst&eacute;m lze
    použ&iacute;vat prostřednictv&iacute;m webov&yacute;ch str&aacute;nek nebo aplikace.
  </p>
  <p>
    Neopr&aacute;vněn&yacute; př&iacute;stup &ndash; př&iacute;stup k &Uacute;čtu nebo Profilu bez
    svolen&iacute; nebo svolen&iacute; Klienta, podvodně, neopr&aacute;vněně nebo jinak
    trestn&yacute;m činem z&iacute;skan&yacute; třet&iacute; osobou (osobami).
  </p>
  <p>
    Neautorizovan&yacute; př&iacute;kaz &ndash; Př&iacute;kaz k proveden&iacute; platebn&iacute;
    transakce, kter&yacute; nebyl Klientem autorizov&aacute;n.
  </p>
  <p>Webov&eacute; str&aacute;nky &ndash; www.swipez.eu.</p>
  <p>OTEVŘEN&Iacute; &Uacute;ČTU</p>
  <p>&Uacute;čet otev&iacute;r&aacute;me na dobu neurčitou.</p>
  <p>
    Pro otevřen&iacute; &uacute;čtu a využ&iacute;v&aacute;n&iacute; na&scaron;ich služeb vyplňte a
    ode&scaron;lete Ž&aacute;dost.
  </p>
  <p>
    Ž&aacute;dost může b&yacute;t vyplněna v listinn&eacute; podobě a pod&aacute;na osobně, pokud
    Klient ž&aacute;d&aacute; o Služby Draph osobně.
  </p>
  <p>
    Klient může vyplnit Ž&aacute;dost elektronicky a odeslat ji prostřednictv&iacute;m
    Syst&eacute;mu, pokud Klient ž&aacute;d&aacute; o Služby Draph na d&aacute;lku.
  </p>
  <p>
    Pouze Klient star&scaron;&iacute; 18 let (osmn&aacute;ct) let, kter&yacute; je způsobil&yacute;
    vstoupit do pr&aacute;vně z&aacute;vazn&eacute;ho vztahu, může ž&aacute;dat a využ&iacute;vat
    na&scaron;e Služby.
  </p>
  <p>
    Nebudete m&iacute;t n&aacute;rok na otevřen&iacute; &uacute;čtu, pokud jste rezidentem, občanem
    nebo pr&aacute;vnickou osobou zapsanou v obchodn&iacute;m rejstř&iacute;ku nebo
    podnikaj&iacute;c&iacute; v zem&iacute;ch, kter&eacute; jsou uvedeny na seznamu
    zak&aacute;zan&yacute;ch zem&iacute;, kter&eacute; jako takov&eacute; uzn&aacute;v&aacute;
    N&aacute;vrh .
  </p>
  <p>
    Chcete-li se zaregistrovat do syst&eacute;mu, měli byste pož&aacute;dat o SCA. Po
    odesl&aacute;n&iacute; Ž&aacute;dosti obdrž&iacute;te ověřovac&iacute; k&oacute;d na sv&eacute;
    telefonn&iacute; č&iacute;slo a ověřovac&iacute; odkaz na e-mailovou adresu, kterou jste uvedli
    v odeslan&eacute; Ž&aacute;dosti. Ověřovac&iacute; odkaz mus&iacute;te potvrdit kliknut&iacute;m
    na něj a zad&aacute;n&iacute;m ověřovac&iacute;ho k&oacute;du zaslan&eacute;ho na
    telefonn&iacute; č&iacute;slo Klienta. Pokud je zadan&yacute; k&oacute;d prav&yacute; a odkaz je
    &uacute;spě&scaron;ně potvrzen, bude vygenerov&aacute;no jedinečn&eacute; heslo pro
    zad&aacute;n&iacute; syst&eacute;mu a zasl&aacute;no na va&scaron;i e-mailovou adresu.
    E-mailov&aacute; adresa uveden&aacute; v Přihl&aacute;&scaron;ce slouž&iacute; jako
    přihla&scaron;ovac&iacute; přihla&scaron;ovac&iacute; &uacute;daje pro vstup do Syst&eacute;mu.
  </p>
  <p>
    Obvykle se pro př&iacute;stup k aplikaci použ&iacute;vaj&iacute; personalizovan&eacute;
    přihla&scaron;ovac&iacute; &uacute;daje pro vstup do syst&eacute;mu.
  </p>
  <p>
    Mus&iacute;te zajistit, aby va&scaron;e přihla&scaron;ovac&iacute; jm&eacute;no a heslo byly v
    bezpeč&iacute;, a zabr&aacute;nit jejich podvodn&eacute;mu použit&iacute; třet&iacute;mi
    osobami. Souhlas&iacute;te s t&iacute;m, že sv&eacute; přihla&scaron;ovac&iacute; jm&eacute;no a
    heslo neprozrad&iacute;te ž&aacute;dn&eacute; třet&iacute; osobě a budete vždy chr&aacute;nit
    tajemstv&iacute; těchto &uacute;dajů. Jste v&yacute;hradně odpovědn&iacute; za použit&iacute;
    sv&eacute;ho přihla&scaron;ovac&iacute;ho jm&eacute;na a hesla (přihla&scaron;ovac&iacute;ch
    &uacute;dajů) a zachov&aacute;n&iacute; důvěrnosti těchto &uacute;dajů.
  </p>
  <p>
    Souhlas&iacute;te s t&iacute;m, že n&aacute;s budete neprodleně informovat v př&iacute;padě, že
    budete m&iacute;t podezřen&iacute; nebo se dozv&iacute;te o neopr&aacute;vněn&eacute;m
    použit&iacute; va&scaron;eho přihla&scaron;ovac&iacute;ho jm&eacute;na a hesla. Ponesete plnou
    odpovědnost a uhrad&iacute;te ve&scaron;ker&eacute; ztr&aacute;ty, ke kter&yacute;m může
    doj&iacute;t v důsledku neopr&aacute;vněn&eacute;ho zpř&iacute;stupněn&iacute;
    přihla&scaron;ovac&iacute;ch &uacute;dajů třet&iacute; osobě, dokud od v&aacute;s
    neobdrž&iacute;me př&iacute;slu&scaron;n&eacute; ozn&aacute;men&iacute;.
  </p>
  <p>
    &Uacute;čet lze otevř&iacute;t pouze po &uacute;pln&eacute;m ověřen&iacute; totožnosti klienta a
    po ř&aacute;dn&eacute;m obdržen&iacute; a schv&aacute;len&iacute; v&scaron;ech dokumentů
    nezbytn&yacute;ch pro ověřen&iacute; totožnosti a pro &uacute;čely KYC .
  </p>
  <p>
    V&scaron;echny informace a dokumenty, kter&eacute; n&aacute;m klient předlož&iacute;,
    mus&iacute; b&yacute;t &uacute;pln&eacute;, přesn&eacute; a pravdiv&eacute;. Klient n&aacute;s
    vždy informuje a aktualizuje tyto informace, kdykoli se změn&iacute;. Neneseme ž&aacute;dnou
    odpovědnost za jakoukoli finančn&iacute; ztr&aacute;tu vypl&yacute;vaj&iacute;c&iacute; z toho,
    že tak klient neučin&iacute;. Vyhrazujeme si pr&aacute;vo kdykoli pož&aacute;dat klienta o
    potvrzen&iacute; spr&aacute;vnosti informac&iacute; a dokumentů, kter&eacute; n&aacute;m již
    byly předloženy, a/nebo o poskytnut&iacute; dal&scaron;&iacute;ch informac&iacute; a
    podpůrn&yacute;ch dokumentů.
  </p>
  <p>
    Souhlasem s Podm&iacute;nkami n&aacute;s t&iacute;mto neodvolatelně opravňujete k tomu, abychom
    od v&aacute;s a/nebo jak&eacute;hokoli Registru, z&aacute;konn&eacute;ho z&aacute;stupce,
    &uacute;věrov&eacute; instituce nebo finančn&iacute; instituce, not&aacute;ře, jak&eacute;hokoli
    obecn&iacute;ho nebo st&aacute;tn&iacute;ho &uacute;řadu, kter&yacute; v&aacute;s identifikoval
    nebo ověřil a ověřil va&scaron;i totožnost, nebo kter&yacute; s v&aacute;mi měl či měl
    obchodn&iacute; vztah, vyž&aacute;dali jak&eacute;koli informace a dokumenty, bez ohledu na
    jejich formu. To plat&iacute; i pro Z&aacute;stupce, ředitele a skutečn&eacute; vlastn&iacute;ky
    pr&aacute;vnick&eacute; osoby, jak&eacute;koli strany z&uacute;častněn&eacute; na
    Platebn&iacute; transakci, např&iacute;klad Pl&aacute;tce, Př&iacute;jemce atd.
  </p>
  <p>
    Abychom splnili na&scaron;e regulačn&iacute; povinnosti a provedli postupy KYC, můžeme
    pož&aacute;dat o poskytnut&iacute; origin&aacute;ln&iacute;ch dokumentů nebo kopi&iacute;
    dokumentů ověřen&yacute;ch osobou opr&aacute;vněnou z&aacute;konem. V samostatn&yacute;ch
    př&iacute;padech můžeme požadovat, aby byly předložen&eacute; dokumenty apostilov&aacute;ny a v
    př&iacute;padě potřeby legalizov&aacute;ny.
  </p>
  <p>
    Pokud Klient odm&iacute;tne poskytnout dal&scaron;&iacute; informace nebo dokumenty, můžeme
    Aplikaci odm&iacute;tnout a neposkytnout Klientovi Služby.
  </p>
  <p>
    Vyhrazujeme si tak&eacute; pr&aacute;vo odm&iacute;tnout přihl&aacute;&scaron;ku t&iacute;m, že
    v tomto ohledu nepod&aacute;me ž&aacute;dn&eacute; vysvětlen&iacute;, na&scaron;e
    odm&iacute;tnut&iacute; v&scaron;ak bude m&iacute;t z&aacute;važn&eacute; a platn&eacute;
    důvody.
  </p>
  <p>
    Pokud je va&scaron;e ž&aacute;dost schv&aacute;lena společnost&iacute; Draph a va&scaron;e
    identita je &uacute;spě&scaron;ně ověřena, můžete pokračovat v syst&eacute;mu a vytvořit si zde
    profil.
  </p>
  <p>
    Po vytvořen&iacute; Profilu bude Klient pokračovat v dotazn&iacute;ku KYC. Typ KYC
    dotazn&iacute;ku, kter&yacute; je třeba vyplnit, z&aacute;vis&iacute; na typu Klienta &ndash;
    fyzick&aacute; nebo pr&aacute;vnick&aacute; osoba.
  </p>
  <p>
    Dotazn&iacute;k KYC je nutn&eacute; vyplnit, abyste splnili povinn&eacute; regulačn&iacute;
    povinnosti Draph v oblasti AML/CTF a abyste plně porozuměli tomu, kdo je klient, jeho povaze a
    typu obchodn&iacute; činnosti/povol&aacute;n&iacute;, &uacute;čelu, k němuž jsou služby určeny,
    abyste z&iacute;skali plnou důvěru, zda je původ finančn&iacute;ch prostředků držen&yacute;ch
    prostřednictv&iacute;m Draph a použ&iacute;van&yacute;ch pro Platebn&iacute; transakce
    z&aacute;konn&yacute; a finančn&iacute; prostředky nepoch&aacute;zej&iacute; z
    nez&aacute;konn&eacute; činnosti, zda nejsou osoby trestně st&iacute;han&eacute; nebo trestně
    st&iacute;han&eacute; osoby nebo osoby st&iacute;han&eacute; teroristy nebo osobami,
    kter&eacute; jsou trestně st&iacute;han&eacute;. nebo chtěl.
  </p>
  <p>
    Je v&yacute;hradně va&scaron;&iacute; odpovědnost&iacute; poskytnout n&aacute;m přesn&eacute;,
    pravdiv&eacute; a platn&eacute; &uacute;daje a informace a uhrad&iacute;te n&aacute;m
    ve&scaron;ker&eacute; ztr&aacute;ty, kter&eacute; mohou nastat v důsledku předložen&iacute;
    nepřesn&yacute;ch nebo neplatn&yacute;ch &uacute;dajů.
  </p>
  <p>
    Pokud klient ž&aacute;d&aacute; o služby Draph na d&aacute;lku, pak by měl proj&iacute;t
    kontrolou živosti a předložit selfie s dokladem totožnosti. V tomto př&iacute;padě
    obdrž&iacute;te odkaz pro ověřen&iacute; živosti na va&scaron;i e-mailovou adresu, kterou jsme u
    n&aacute;s registrovali. Poskytneme v&aacute;m jasn&eacute; pokyny pro živost a kontrolu selfie.
  </p>
  <p>
    Pokud Z&aacute;stupce použije &uacute;čet, mus&iacute; b&yacute;t předloženy dokumenty
    Z&aacute;stupce potvrzuj&iacute;c&iacute; pr&aacute;vn&iacute; důvod jeho/jej&iacute;ho
    zastoupen&iacute;, použij&iacute; se ověřen&iacute; identity a postupy KYC, jak je uvedeno
    v&yacute;&scaron;e.
  </p>
  <p>
    V př&iacute;padě, že je &Uacute;čet zř&iacute;zen ve prospěch třet&iacute; osoby &ndash;
    skutečn&eacute;ho vlastn&iacute;ka, pak tato osoba podl&eacute;h&aacute; ověřen&iacute;
    totožnosti a kontrol&aacute;m KYC, kter&eacute; Draph na soukrom&eacute; osoby uplatňuje.
  </p>
  <p>
    &Uacute;čet bude otevřen a Služby mohou b&yacute;t poskytov&aacute;ny pouze v př&iacute;padě, že
    Klient, Z&aacute;stupce nebo osoba, v jej&iacute;ž prospěch je &Uacute;čet otevřen (pokud
    existuje), bude plně ověřen, v&scaron;echny kontroly a povinn&eacute; prověrky
    &uacute;spě&scaron;ně projdou a Draph plně rozum&iacute; tomu, kdo je Klientem.
  </p>
  <p>
    Draph za ž&aacute;dn&yacute;ch okolnost&iacute; neotevře &Uacute;čet a neposkytuje Služby,
    pokud:
  </p>
  <p>
    Klient, Z&aacute;stupce nebo osoba, v jej&iacute;ž prospěch je &Uacute;čet zř&iacute;zen (pokud
    existuje), nen&iacute; plně ověřen,
  </p>
  <p>
    nalezeny a potvrzeny pozitivn&iacute; shody se seznamy sankc&iacute;, seznamy
    zablokovan&yacute;ch a speci&aacute;lně určen&yacute;ch osob, seznamy hledan&yacute;ch osob atd.
    ve vztahu ke Klientovi, Z&aacute;stupci nebo osobě, v jej&iacute;ž prospěch je &Uacute;čet
    zř&iacute;zen (pokud existuje),
  </p>
  <p>
    jsou nalezena negativn&iacute; nepř&iacute;zniv&aacute; m&eacute;dia obklopuj&iacute;c&iacute;
    Klienta, Z&aacute;stupce nebo osobu, v jej&iacute;ž prospěch je &Uacute;čet zř&iacute;zen (pokud
    existuje),
  </p>
  <p>
    Klient sv&yacute;mi geografick&yacute;mi vazbami (m&iacute;sto narozen&iacute;, z&aacute;pis do
    obchodn&iacute;ho rejstř&iacute;ku, st&aacute;tn&iacute; občanstv&iacute;, bydli&scaron;tě,
    m&iacute;sto podnik&aacute;n&iacute; atd.), povaha a typ podnikatelsk&eacute; činnosti nebo
    povol&aacute;n&iacute; spad&aacute; pod nespolupracuj&iacute;c&iacute; (zak&aacute;zan&eacute;)
    v souladu s n&aacute;vrhem stanoven&yacute;mi intern&iacute;mi pravidly a postupy AML/CTF,
  </p>
  <p>
    je zji&scaron;těno, že peněžn&iacute; prostředky, kter&eacute; Klient hodl&aacute; použ&iacute;t
    k Platebn&iacute;m transakc&iacute;m, jsou neleg&aacute;ln&iacute;ho/trestn&eacute;ho původu,
    nebo nen&iacute; možn&eacute; původ těchto peněžn&iacute;ch prostředků identifikovat,
  </p>
  <p>
    spolupr&aacute;ce s Klientem může představovat Draph , jeho partnery a prodejce a
    dal&scaron;&iacute; Klienty v&yacute;znamn&eacute; reputačn&iacute; riziko.
  </p>
  <p>
    Za ž&aacute;dn&yacute;ch okolnost&iacute; nejsou zakl&aacute;d&aacute;ny anonymn&iacute;
    &Uacute;čty a nejsou prov&aacute;děny anonymn&iacute; Platebn&iacute; transakce.
  </p>
  <p>
    Při zř&iacute;zen&iacute; &Uacute;čtu pro Klienta, kter&yacute; je soukromou osobou, se
    m&aacute; za to, že takov&yacute; Klient jedn&aacute; v&yacute;hradně pro nekomerčn&iacute;
    &uacute;čely, v opačn&eacute;m př&iacute;padě bude zř&iacute;zen Podnikatelsk&yacute;
    &uacute;čet.
  </p>
  <p>Prostředky na &Uacute;čtu (&uacute;čtech) nejsou &uacute;ročeny.</p>
  <p>
    Klient se t&iacute;mto zavazuje k N&aacute;vrhu , že otevřen&iacute; a
    použ&iacute;v&aacute;n&iacute; &Uacute;čtu (&uacute;čtů) neporu&scaron;uje ž&aacute;dn&eacute;
    z&aacute;kony platn&eacute; pro Klienta nebo N&aacute;vrh a Klient nese plnou odpovědnost, pokud
    se z&aacute;vazky zde uveden&eacute; uk&aacute;ž&iacute; jako nepravdiv&eacute; a
    zav&aacute;děj&iacute;c&iacute;.
  </p>
  <p>
    Vyhrazujeme si pr&aacute;vo nezaložit &Uacute;čet a/nebo &Uacute;čet bez ud&aacute;n&iacute;
    důvodu zavř&iacute;t, nicm&eacute;ně na&scaron;e rozhodnut&iacute; bude m&iacute;t
    v&yacute;znamn&yacute; a platn&yacute; důvod.
  </p>
  <p>POUŽ&Iacute;V&Aacute;N&Iacute; &Uacute;ČTU</p>
  <p>
    &Uacute;čet je pro Klienta osobn&iacute;, je otevřen na jm&eacute;no Klienta a Klient
    nesm&iacute; postoupit ž&aacute;dn&aacute; pr&aacute;va podle těchto Podm&iacute;nek
    ž&aacute;dn&eacute; třet&iacute; straně.
  </p>
  <p>
    Ve&scaron;ker&eacute; činnosti na &Uacute;čtu se považuj&iacute; za činnosti
    prov&aacute;děn&eacute; Klientem jako registrovan&yacute;m uživatelem.
  </p>
  <p>
    Klient si může založit pouze jeden &Uacute;čet. V př&iacute;padě zji&scaron;těn&iacute;
    duplicitn&iacute;ch &uacute;čtů můžeme tyto duplicitn&iacute; &uacute;čty podle vlastn&iacute;ho
    uv&aacute;žen&iacute; uzavř&iacute;t nebo sloučit.
  </p>
  <p>
    &Uacute;čet umožňuje Klientovi prov&aacute;dět SEPA a SWIFT platby,
    vnitrosyst&eacute;mov&eacute; platby a přev&aacute;dět měny.
  </p>
  <p>
    Lze otevř&iacute;t v&iacute;ceměnov&yacute; &uacute;čet. Dostupn&eacute; měny a směnn&eacute;
    kurzy jsou k dispozici v profilu. Měna se směňuje na z&aacute;kladě směnn&yacute;ch kurzů
    platn&yacute;ch v okamžiku přepočtu.
  </p>
  <p>Na&scaron;e služby zahrnuj&iacute;:</p>
  <p>
    Platebn&iacute; transakce z &uacute;čtů Draph na bankovn&iacute; &uacute;čty nebo &uacute;čty
    jin&yacute;ch poskytovatelů platebn&iacute;ch služeb, a to buď ve formě převodů SWIFT/SEPA a
    (nebo) m&iacute;stn&iacute;ch bankovn&iacute;ch převodů, pokud je to možn&eacute; a
    dostupn&eacute;,
  </p>
  <p>
    Platebn&iacute; transakce na &uacute;čty Draph z bankovn&iacute;ch &uacute;čtů nebo &uacute;čtů
    jin&yacute;ch poskytovatelů platebn&iacute;ch služeb,
  </p>
  <p>směn&aacute;rna,</p>
  <p>intern&iacute; Platebn&iacute; transakce mezi &uacute;čty Draph .</p>
  <p>
    Banky a poskytovatel&eacute; platebn&iacute;ch služeb si mohou za prov&aacute;děn&iacute;
    Platebn&iacute;ch transakc&iacute; &uacute;čtovat vlastn&iacute; poplatky. Společnost Draph je
    zpro&scaron;těna jak&eacute;koli odpovědnosti nebo n&aacute;hrady v&yacute;dajů s
    v&yacute;hradou př&iacute;slu&scaron;n&yacute;ch poplatků bank nebo poskytovatelů
    platebn&iacute;ch služeb.
  </p>
  <p>
    Draph může &Uacute;čtům stanovit limity v z&aacute;vislosti na typu rizika pran&iacute;
    &scaron;pinav&yacute;ch peněz ("ML") , kter&yacute; Klientovi přidělil Draph . Limity jsou
    stanoveny a upraveny podle vlastn&iacute;ho uv&aacute;žen&iacute; Draph .
  </p>
  <p>
    Je př&iacute;sně zak&aacute;z&aacute;no použ&iacute;vat &Uacute;čet k finančn&iacute;m
    prostředkům z&iacute;skan&yacute;m v důsledku trestn&eacute; činnosti nebo použ&iacute;vat
    Služby/&Uacute;čet k jak&yacute;mkoli nez&aacute;konn&yacute;m &uacute;čelům, mimo jin&eacute;
    včetně podvodů, pran&iacute; &scaron;pinav&yacute;ch peněz a/nebo financov&aacute;n&iacute;
    terorismu. V takov&eacute;m př&iacute;padě je Draph opr&aacute;vněn okamžitě pozastavit
    poskytov&aacute;n&iacute; Služeb, zablokovat ve&scaron;ker&eacute; operace na &Uacute;čtech,
    &bdquo;zmrazit&ldquo; peněžn&iacute; prostředky na &Uacute;čtech a nahl&aacute;sit jakoukoli
    podezřelou aktivitu př&iacute;slu&scaron;n&eacute;mu org&aacute;nu.
  </p>
  <p>
    V&scaron;echny Platebn&iacute; transakce Klienta (včetně Zůstatku na &Uacute;čtu,
    peněžn&iacute;ch prostředků, kter&eacute; byly nahr&aacute;ny, přijaty, odesl&aacute;ny,
    vybr&aacute;ny nebo vyměněny) jsou zaznamen&aacute;ny v sekci Historie operac&iacute; v Profilu.
    Klient m&aacute; k těmto informac&iacute;m bezplatn&yacute; př&iacute;stup po
    přihl&aacute;&scaron;en&iacute; do Profilu.
  </p>
  <p>
    Klient souhlas&iacute; a přij&iacute;m&aacute; v&scaron;echna rizika spojen&aacute; s
    udržov&aacute;n&iacute;m zůstatků na &uacute;čtu ve v&iacute;ce měn&aacute;ch, včetně
    v&scaron;ech rizik spojen&yacute;ch s kol&iacute;s&aacute;n&iacute;m
    př&iacute;slu&scaron;n&yacute;ch směnn&yacute;ch kurzů v průběhu času. Klient se zavazuje, že
    nebude využ&iacute;vat Služby ke spekulativn&iacute;mu obchodov&aacute;n&iacute;.
  </p>
  <p>
    Klient se zavazuje m&iacute;t vždy nulov&yacute; nebo kladn&yacute; zůstatek na &uacute;čtu.
    Pokud se Klientův &uacute;čet dostane do z&aacute;porn&eacute;ho zůstatku v důsledku
    zpětn&eacute;ho z&uacute;čtov&aacute;n&iacute;, zru&scaron;en&iacute; transakce, sr&aacute;žky
    poplatků nebo jak&eacute;hokoli jin&eacute;ho &uacute;konu proveden&eacute;ho Klientem, Klient
    se zavazuje z&aacute;porn&yacute; zůstatek okamžitě splatit, aniž bychom to museli
    ohl&aacute;sit.
  </p>
  <p>
    Vyhrazujeme si pr&aacute;vo podniknout přiměřen&eacute; kroky k vym&aacute;h&aacute;n&iacute;
    z&aacute;porn&eacute;ho zůstatku na &uacute;čtu od Klienta, např&iacute;klad podniknout
    dal&scaron;&iacute; pr&aacute;vn&iacute; kroky, využ&iacute;t služeb
    vym&aacute;h&aacute;n&iacute; pohled&aacute;vek a &uacute;čtovat Klientovi ve&scaron;ker&eacute;
    n&aacute;klady a v&yacute;daje, kter&eacute; mohou společnosti Draph vzniknout. Klient
    souhlas&iacute; s t&iacute;m, že v&scaron;echny takov&eacute; n&aacute;klady a v&yacute;daje
    plně uhrad&iacute; N&aacute;vrhu .
  </p>
  <p>OBJEDN&Aacute;VKA</p>
  <p>
    Pokažd&eacute;, když chce Klient prov&eacute;st Platebn&iacute; transakci, měl by b&yacute;t
    vyplněn př&iacute;slu&scaron;n&yacute; Př&iacute;kaz a odesl&aacute;n do Draphu k
    dal&scaron;&iacute;mu proveden&iacute;.
  </p>
  <p>
    Objedn&aacute;vka bude vyplněna v Profilu v souladu s pokyny uveden&yacute;mi v Syst&eacute;mu.
    &Uacute;daje o Pl&aacute;tci nebo Př&iacute;jemci by měly b&yacute;t platn&eacute; v okamžiku
    převodu.
  </p>
  <p>Objedn&aacute;vka by měla obsahovat n&aacute;sleduj&iacute;c&iacute; souč&aacute;sti:</p>
  <p>č&aacute;stku platebn&iacute; transakce,</p>
  <p>měna,</p>
  <p>&uacute;daje potřebn&eacute; k identifikaci př&iacute;jemce,</p>
  <p>datum proveden&iacute; Objedn&aacute;vky a</p>
  <p>jak&eacute;koli dal&scaron;&iacute; požadovan&eacute; informace.</p>
  <p>
    Pokud to bude před proveden&iacute;m Př&iacute;kazu považov&aacute;no za přiměřeně nutn&eacute;,
    můžeme si vyž&aacute;dat podpůrn&eacute; informace o Platebn&iacute; transakci (včetně
    podpůrn&yacute;ch dokumentů). Objedn&aacute;vka bude provedena až po včasn&eacute;m
    poskytnut&iacute; požadovan&yacute;ch informac&iacute; (term&iacute;n pod&aacute;n&iacute;
    informac&iacute; v&aacute;m bude ozn&aacute;men v okamžiku ž&aacute;dosti o informace), v
    pln&eacute;m rozsahu a ke spokojenosti společnosti Draph . Pokud požadovan&eacute; informace
    nebudou poskytnuty nebo nebudou poskytnuty včas, v pln&eacute;m rozsahu nebo nebudou vyhovovat
    N&aacute;vrhu , Objedn&aacute;vka bude z na&scaron;&iacute; strany zru&scaron;ena; v
    př&iacute;padě př&iacute;choz&iacute;ch Platebn&iacute;ch transakc&iacute; budou
    př&iacute;choz&iacute; peněžn&iacute; prostředky vr&aacute;ceny Pl&aacute;tci.
  </p>
  <p>
    Chcete-li odeslat objedn&aacute;vku, měli byste kliknout na kartu ověřen&iacute; v
    syst&eacute;mu a autorizovat objedn&aacute;vku pomoc&iacute; sv&yacute;ch osobn&iacute;ch
    &uacute;dajů. Když kliknete na z&aacute;ložku ověřen&iacute; a Objedn&aacute;vka je
    autorizov&aacute;na , Objedn&aacute;vka se stane neodvolatelnou.
  </p>
  <p>
    Platebn&iacute; transakce bude provedena nejpozději n&aacute;sleduj&iacute;c&iacute;
    Pracovn&iacute; den po datu, kdy je Př&iacute;kaz z Va&scaron;&iacute; strany potvrzen
    prostřednictv&iacute;m Syst&eacute;mu. Pokud datum odesl&aacute;n&iacute; Př&iacute;kazu
    nen&iacute; Pracovn&iacute; den, bude se m&iacute;t za to, že Př&iacute;kaz byl přijat
    n&aacute;sleduj&iacute;c&iacute; Pracovn&iacute; den.
  </p>
  <p>
    Platebn&iacute; transakce v r&aacute;mci Syst&eacute;mu jsou prov&aacute;děny ihned po
    zad&aacute;n&iacute; Př&iacute;kazu, pokud nen&iacute; transakce pozastavena z důvodu
    ustanoven&iacute; uveden&yacute;ch v tomto dokumentu.
  </p>
  <p>
    V př&iacute;padě zad&aacute;n&iacute; nespr&aacute;vn&eacute;ho Př&iacute;kazu, ale
    Platebn&iacute; převod je&scaron;tě neproběhl, může Klient pož&aacute;dat o opravu
    Př&iacute;kazu. Společnost Draph si může za opravu Objedn&aacute;vky &uacute;čtovat poplatek.
  </p>
  <p>
    Pokud zjist&iacute;me zjevn&eacute; nesrovnalosti v podrobnostech objedn&aacute;vky, vyhrazujeme
    si pr&aacute;vo na z&aacute;kladě vlastn&iacute;ho uv&aacute;žen&iacute; odm&iacute;tnout
    proveden&iacute; takov&eacute; objedn&aacute;vky.
  </p>
  <p>
    Draph může prov&eacute;st Př&iacute;kaz pouze na z&aacute;kladě č&iacute;sla &uacute;čtu .
    Můžeme, ale nejsme povinni, zkontrolovat, zda č&iacute;slo &uacute;čtu odpov&iacute;d&aacute;
    jm&eacute;nu Př&iacute;jemce nebo Pl&aacute;tce. Př&iacute;kaz se považuje za ř&aacute;dně
    proveden&yacute;, pokud byl proveden z uveden&eacute;ho č&iacute;sla &uacute;čtu.
  </p>
  <p>
    Objedn&aacute;vku zru&scaron;&iacute;me a přijat&eacute; prostředky vr&aacute;t&iacute;me
    Pl&aacute;tci, pokud je nejsme schopni připsat na &Uacute;čet Př&iacute;jemce (např. &uacute;čet
    je uzavřen nebo činnost &uacute;čtu pozastavena, uveden&eacute; č&iacute;slo &uacute;čtu
    neexistuje, je na &uacute;čtu z&aacute;porn&yacute; zůstatek nebo jinak). Předkladatel může za
    vr&aacute;cen&iacute; prostředků &uacute;čtovat poplatek. V tomto př&iacute;padě by měla
    b&yacute;t přijata ž&aacute;dost pl&aacute;tce o vr&aacute;cen&iacute; peněz.
  </p>
  <p>
    Pokud jste si v&scaron;imli, že finančn&iacute; prostředky byly přips&aacute;ny nebo odečteny z
    &Uacute;čtu omylem nebo z důvodu nespr&aacute;vn&eacute;ho Př&iacute;kazu, jste povinni
    n&aacute;s o tom co nejdř&iacute;ve informovat. Dokud nebudeme ř&aacute;dně upozorněni na chybu,
    m&aacute; se za to, že Klient s takov&yacute;m převodem prostředků d&aacute;v&aacute;
    neodvolateln&yacute; souhlas.
  </p>
  <p>
    Pokud již byly peněžn&iacute; prostředky přips&aacute;ny na &Uacute;čet Př&iacute;jemce, můžeme
    prostředky vr&aacute;tit Pl&aacute;tci pouze na z&aacute;kladě p&iacute;semn&eacute;ho souhlasu
    Př&iacute;jemce s vr&aacute;cen&iacute;m č&aacute;stky transakce z jeho &Uacute;čtu. Měla by
    b&yacute;t pod&aacute;na ž&aacute;dost pl&aacute;tce o vr&aacute;cen&iacute; peněz.
  </p>
  <p>
    Před proveden&iacute;m Př&iacute;kazu zkontrolujeme Zůstatek na &uacute;čtu, zda je dostatek
    finančn&iacute;ch prostředků k proveden&iacute; Př&iacute;kazu, a odečteme
    př&iacute;slu&scaron;n&eacute; poplatky, jak je dohodnuto v Sazebn&iacute;ku. Pokud je
    č&aacute;stka disponibiln&iacute;ch prostředků k proveden&iacute; Př&iacute;kazu
    niž&scaron;&iacute; než č&aacute;stka Platebn&iacute; transakce (včetně poplatků), Př&iacute;kaz
    je automaticky odm&iacute;tnut. Informace o odm&iacute;tnut&iacute; platby jsou v&aacute;m
    zpř&iacute;stupněny v Profilu.
  </p>
  <p>
    Pokud m&aacute; Draph n&aacute;rok na &uacute;platu, ale zůstatek na &uacute;čtu je
    z&aacute;porn&yacute;, klient se bezpodm&iacute;nečně zavazuje na na&scaron;i prvn&iacute;
    ž&aacute;dost okamžitě nahr&aacute;t zůstatek na &uacute;čtu za nedostatečnou č&aacute;stku.
  </p>
  <p>
    Dokud nebude zůstatek na &uacute;čtu nedostatečn&yacute; k pokryt&iacute; v&scaron;ech poplatků
    splatn&yacute;ch a splatn&yacute;ch Draphovi , vyhrazujeme si pr&aacute;vo pozastavit
    poskytov&aacute;n&iacute; Služeb a činnost &Uacute;čtu. Vyhrazujeme si pr&aacute;vo bez
    předchoz&iacute;ho souhlasu Klienta st&aacute;hnout splatnou č&aacute;stku poplatků,
    kter&aacute; n&aacute;m m&aacute; b&yacute;t splatn&aacute;, z jak&yacute;chkoli prostředků
    dobit&yacute;ch na Klientův &uacute;čet (&uacute;čty).
  </p>
  <p>
    Vyhrazujeme si pr&aacute;vo uplatnit &uacute;rok z prodlen&iacute; z důvodu Draph ve
    v&yacute;&scaron;i 0,05 % z č&aacute;stky prodlen&iacute; za každ&yacute; den prodlen&iacute;.
    Jsme opr&aacute;vněni vybrat č&aacute;stku &uacute;roku z prostředků na &Uacute;čtu
    (&uacute;čtech) bez předchoz&iacute;ho souhlasu Klienta.
  </p>
  <p>
    Pokud byl Př&iacute;kaz chybně proveden z důvodu p&aacute;du Draphu , vr&aacute;t&iacute;me
    v&aacute;m č&aacute;stku nespr&aacute;vně proveden&eacute; Platebn&iacute; transakce. Klientovi
    tak&eacute; vr&aacute;t&iacute;me v&scaron;echny poplatky, kter&eacute; my, banka nebo
    poskytovatel platebn&iacute;ch služeb &uacute;čtujeme za proveden&iacute; Platebn&iacute;
    transakce.
  </p>
  <p>
    Pokud budou finančn&iacute; prostředky převeden&eacute; z &Uacute;čtu na z&aacute;kladě
    předložen&eacute;ho Př&iacute;kazu vr&aacute;ceny z důvodů, kter&eacute; nemůžeme ovlivnit, bude
    vr&aacute;cen&aacute; č&aacute;stka přips&aacute;na na &Uacute;čet. Poplatky zaplacen&eacute;
    Pl&aacute;tcem za proveden&iacute; Př&iacute;kazu se nevrac&iacute;, dal&scaron;&iacute;
    poplatky souvisej&iacute;c&iacute; s vr&aacute;cen&iacute;m peněžn&iacute;ch prostředků mohou
    b&yacute;t strženy z &Uacute;čtu.
  </p>
  <p>
    Zadan&eacute; př&iacute;kazy mus&iacute; b&yacute;t formulov&aacute;ny jasně a jednoznačně,
    mus&iacute; b&yacute;t vykonateln&eacute; a obsahovat jasně danou vůli Klienta. Neneseme
    odpovědnost za chyby, nesrovnalosti, opakov&aacute;n&iacute; a/nebo rozpory v zaslan&yacute;ch
    Objedn&aacute;vk&aacute;ch, včetně, ale nikoli v&yacute;hradně, za spr&aacute;vnost &uacute;dajů
    Objedn&aacute;vky předložen&eacute; Klientem. Pokud zadan&aacute; Objedn&aacute;vka neobsahuje
    dostatek &uacute;dajů nebo obsahuje nedostatky, můžeme proveden&iacute; takov&eacute;
    Objedn&aacute;vky odm&iacute;tnout nebo ji prov&eacute;st v souladu s &uacute;daji
    uveden&yacute;mi v Objedn&aacute;vce.
  </p>
  <p>
    Pokud z rozumn&yacute;ch důvodů odm&iacute;tneme proveden&iacute; Př&iacute;kazu, okamžitě
    v&aacute;s o tom informujeme, s v&yacute;jimkou př&iacute;padů, kdy je takov&eacute;
    ozn&aacute;men&iacute; technicky nemožn&eacute; nebo zak&aacute;zan&eacute; platn&yacute;mi
    z&aacute;kony a předpisy.
  </p>
  <p>
    V ž&aacute;dn&eacute;m př&iacute;padě Př&iacute;kaz neprovedeme, pokud jsou finančn&iacute;
    prostředky na &Uacute;čtu zadrženy nebo jsou pr&aacute;va Klienta nakl&aacute;dat s
    finančn&iacute;mi prostředky jinak pr&aacute;vně omezena, pozastavena nebo omezena.
  </p>
  <p>
    Po zad&aacute;n&iacute; a autorizaci prostřednictv&iacute;m Syst&eacute;mu a po datu, kdy je
    považov&aacute;n za neodvolateln&yacute;, nemůže Klient odvolat.
  </p>
  <p>
    Vyhrazujeme si pr&aacute;vo evidovat a uchov&aacute;vat zadan&eacute; Př&iacute;kazy a evidovat
    a uchov&aacute;vat informace o v&scaron;ech Platebn&iacute;ch transakc&iacute;ch
    proveden&yacute;ch Klienty po dobu 10 (deseti) let, kter&aacute; může b&yacute;t prodloužena,
    pokud n&aacute;m to ukl&aacute;d&aacute; př&iacute;slu&scaron;n&yacute; z&aacute;kon.
    Z&aacute;znamy uveden&eacute; v tomto čl&aacute;nku mohou b&yacute;t předloženy Klientovi a/nebo
    třet&iacute;m osob&aacute;m, kter&eacute; maj&iacute; pr&aacute;vo tyto &uacute;daje obdržet v
    souladu s platn&yacute;mi z&aacute;kony a předpisy, jako důkaz potvrzuj&iacute;c&iacute;
    pod&aacute;n&iacute; Př&iacute;kazu a/nebo proveden&iacute; Platebn&iacute; transakce.
  </p>
  <p>AUTORIZACE OBJEDN&Aacute;VKY A SYST&Eacute;M</p>
  <p>
    Každ&yacute; Př&iacute;kaz před proveden&iacute;m mus&iacute; b&yacute;t Klientem
    autorizov&aacute;n v Syst&eacute;mu. Klient může použ&iacute;vat Syst&eacute;m
    prostřednictv&iacute;m Webov&eacute; str&aacute;nky.
  </p>
  <p>
    Pro autorizaci Objedn&aacute;vky byste měli použ&iacute;t sv&eacute; osobn&iacute;
    přihla&scaron;ovac&iacute; &uacute;daje a postupovat podle na&scaron;ich pokynů uveden&yacute;ch
    v Syst&eacute;mu.
  </p>
  <p>
    Obvykle požadujeme dvoufaktorovou autentizaci (2FA), kter&aacute; se skl&aacute;d&aacute;
    alespoň z va&scaron;eho osobn&iacute;ho hesla a přihla&scaron;ovac&iacute;ho jm&eacute;na.
  </p>
  <p>Pokud objedn&aacute;vku neautorizujete , bude objedn&aacute;vka zru&scaron;ena .</p>
  <p>
    V př&iacute;padě reklamac&iacute; t&yacute;kaj&iacute;c&iacute;ch se Neopr&aacute;vněn&eacute;
    objedn&aacute;vky se na n&aacute;s laskavě obraťte prostřednictv&iacute;m komunikačn&iacute;ch
    kan&aacute;lů uveden&yacute;ch v Podm&iacute;nk&aacute;ch co nejdř&iacute;ve pot&eacute;, co
    jste se o anom&aacute;lii dozvěděli, a to do 13 (13) měs&iacute;ců od data
    odesl&aacute;n&iacute; Neopr&aacute;vněn&eacute; objedn&aacute;vky.
  </p>
  <p>
    Po ověřen&iacute; opr&aacute;vněnosti a pro&scaron;etřen&iacute; va&scaron;eho požadavku ohledně
    Neopr&aacute;vněn&eacute;ho př&iacute;kazu, nejpozději do 5 (pěti) Pracovn&iacute;ch dnů po
    ověřen&iacute; opr&aacute;vněnosti a pro&scaron;etřen&iacute; požadavku zajist&iacute;me
    vr&aacute;cen&iacute; č&aacute;stky Neopr&aacute;vněn&eacute;ho př&iacute;kazu a obnov&iacute;me
    &Uacute;čet na č&aacute;stku, kterou by obsahoval, kdyby sporn&aacute; transakce nebyla nikdy
    provedena, včetně v&scaron;ech souvisej&iacute;c&iacute;ch poplatků.
  </p>
  <p>
    V př&iacute;padě ztr&aacute;ty nebo kr&aacute;deže va&scaron;ich přihla&scaron;ovac&iacute;ch
    &uacute;dajů (přihla&scaron;ovac&iacute; jm&eacute;no a heslo) nebo v př&iacute;padě, že jste
    neuchovali sv&eacute; bezpečnostn&iacute; informace v bezpeč&iacute;, můžete b&yacute;t
    odpovědn&iacute; za neopr&aacute;vněnou objedn&aacute;vku provedenou před
    ozn&aacute;men&iacute;m sporu.
  </p>
  <p>
    S v&yacute;jimkou př&iacute;padů, kdy jste nejednali podvodně, nebudete odpovědn&iacute; za
    ž&aacute;dn&eacute; ztr&aacute;ty vznikl&eacute; v souvislosti s neopr&aacute;vněnou
    objedn&aacute;vkou, ke kter&yacute;m dojde pot&eacute;, co jste n&aacute;s informovali o
    ztr&aacute;tě, kr&aacute;deži, zpronevěře nebo opr&aacute;vněn&eacute;m použit&iacute;
    va&scaron;ich přihla&scaron;ovac&iacute;ch &uacute;dajů.
  </p>
  <p>
    Nezaručujeme nepřetržit&yacute; provoz syst&eacute;mu nebo aplikace, protože provoz
    syst&eacute;mu nebo aplikace může b&yacute;t ovlivněn (naru&scaron;en) mnoha faktory,
    kter&eacute; nemůžeme ovlivnit. Vynalož&iacute;me ve&scaron;ker&eacute; &uacute;sil&iacute; na
    to, abychom zajistili co nejplynulej&scaron;&iacute; provoz Syst&eacute;mu a Aplikace, neneseme
    v&scaron;ak odpovědnost za n&aacute;sledky vznikl&eacute; v důsledku poruch provozu
    Syst&eacute;mu nebo Aplikace, pokud k takov&yacute;m poruch&aacute;m dojde nikoli z
    na&scaron;&iacute; viny.
  </p>
  <p>
    Neodvolatelně souhlas&iacute;te s t&iacute;m, že syst&eacute;m, webov&aacute; str&aacute;nka a
    aplikace budou použ&iacute;v&aacute;ny &bdquo;tak, jak jsou&ldquo; a my neneseme odpovědnost a
    neneseme ž&aacute;dnou odpovědnost za ztr&aacute;tu nebo odměnu, pokud dojde k jak&yacute;mkoli
    chyb&aacute;m nebo jin&yacute;m technick&yacute;m přeru&scaron;en&iacute;m způsoben&yacute;m
    vinou jak&eacute;koli třet&iacute; strany nebo jin&yacute;mi ud&aacute;lostmi mimo na&scaron;i
    kontrolu.
  </p>
  <p>
    V př&iacute;padě pl&aacute;novan&eacute; technick&eacute; &uacute;držby Syst&eacute;mu, Webu
    nebo Aplikace v&aacute;s budeme předem informovat s upřesněn&iacute;m
    předpokl&aacute;dan&eacute; doby přeru&scaron;en&iacute; provozu. V př&iacute;padě
    nepředv&iacute;dan&yacute;ch technick&yacute;ch chyb v&aacute;s můžeme informovat post factum,
    z&aacute;roveň v r&aacute;mci na&scaron;ich možnost&iacute; a jednaj&iacute;c&iacute; v
    dobr&eacute; v&iacute;ře a snažit se co nejdř&iacute;ve obnovit funkčnost Syst&eacute;mu, Webu
    nebo Aplikace.
  </p>
  <p>
    Aniž by byla dotčena ostatn&iacute; ustanoven&iacute; zde uveden&aacute;, vyhrazujeme si
    pr&aacute;vo okamžitě pozastavit nebo odebrat v&aacute;&scaron; př&iacute;stup do Syst&eacute;mu
    (jak prostřednictv&iacute;m Webov&eacute; str&aacute;nky, tak aplikace) a &Uacute;čtu
    (&uacute;čtů), včetně prov&aacute;děn&iacute; Platebn&iacute;ch transakc&iacute;, pokud se
    důvodně domn&iacute;v&aacute;me, že:
  </p>
  <p>může doj&iacute;t k naru&scaron;en&iacute; bezpečnosti syst&eacute;mu,</p>
  <p>
    m&aacute;me podezřen&iacute; na neopr&aacute;vněn&eacute; nebo podvodn&eacute; použit&iacute;
    syst&eacute;mu, profilu nebo &uacute;čtu (&uacute;čtů),
  </p>
  <p>
    jsme povinni tak učinit, abychom chr&aacute;nili opr&aacute;vněn&eacute; z&aacute;jmy
    na&scaron;ich nebo na&scaron;ich klientů.
  </p>
  <p>to n&aacute;m ukl&aacute;d&aacute; z&aacute;kon.</p>
  <p>
    Předem v&aacute;s upozorn&iacute;me na va&scaron;e omezen&iacute; př&iacute;stupu, kromě
    př&iacute;padů, kdy to nen&iacute; možn&eacute; nebo zak&aacute;z&aacute;no z&aacute;konem,
    pot&eacute; v&aacute;s budeme informovat při nejbliž&scaron;&iacute; př&iacute;ležitosti.
    Jakmile pominou důvody pro omezen&iacute; př&iacute;stupu, bez zbytečn&eacute;ho odkladu
    v&aacute;m obnov&iacute;me př&iacute;stup do Syst&eacute;mu nebo v&aacute;m vystav&iacute;me
    nov&eacute; přihla&scaron;ovac&iacute; &uacute;daje.
  </p>
  <p>
    Sv&eacute; osobn&iacute; př&iacute;stupov&eacute; &uacute;daje &ndash;
    přihla&scaron;ovac&iacute; jm&eacute;no a heslo &ndash; mus&iacute;te vždy uchov&aacute;vat v
    bezpeč&iacute; a nikdy je nesdělovat třet&iacute;m stran&aacute;m.
  </p>
  <p>
    Klientovi se doporučuje uchov&aacute;vat osobn&iacute; př&iacute;stupov&eacute; &uacute;daje v
    bezpeč&iacute; podle n&aacute;sleduj&iacute;c&iacute;ch doporučen&iacute;:
  </p>
  <p>
    pravidelně měňte heslo a zajistěte, aby nebylo znovu použito na jin&yacute;ch online
    &uacute;čtech,
  </p>
  <p>
    odhlaste se ze syst&eacute;mu a ukončete aplikaci pokažd&eacute;, když ji
    nepouž&iacute;v&aacute;te,
  </p>
  <p>
    proveďte pečlivě v&scaron;echny kroky SCA při přihla&scaron;ov&aacute;n&iacute; do
    Syst&eacute;mu a autorizaci Objedn&aacute;vky,
  </p>
  <p>nedovolte nikomu přistupovat k va&scaron;emu profilu ani sledovat, jak k němu přistupujete,</p>
  <p>
    nepouž&iacute;vat ž&aacute;dnou funkcionalitu, kter&aacute; umožňuje ukl&aacute;dat
    přihla&scaron;ovac&iacute; &uacute;daje nebo hesla v poč&iacute;tači/mobilu nebo
    prohl&iacute;žeči, kter&yacute; klient použ&iacute;v&aacute;, nebo je ukl&aacute;dat do
    mezipaměti či jinak zaznamen&aacute;vat,
  </p>
  <p>
    udržovat zabezpečen&yacute; e-mailov&yacute; &uacute;čet souvisej&iacute;c&iacute; se
    Syst&eacute;mem,
  </p>
  <p>
    informujte n&aacute;&scaron; t&yacute;m z&aacute;kaznick&eacute; podpory o společnosti Draph ,
    pokud někdo jm&eacute;nem společnosti Draph nebo někoho jin&eacute;ho pož&aacute;d&aacute; o
    pověřen&iacute; pro př&iacute;stup k syst&eacute;mu.
  </p>
  <p>
    Heslo pro př&iacute;stup do syst&eacute;mu můžete resetovat pomoc&iacute; sv&eacute;
    e-mailov&eacute; adresy a telefonn&iacute;ho č&iacute;sla. Klient mus&iacute; okamžitě
    informovat n&aacute;&scaron; t&yacute;m z&aacute;kaznick&eacute; podpory, pokud dojde k
    prolomen&iacute; e-mailov&eacute; adresy nebo telefonu, odcizen&iacute; telefonu atd.
  </p>
  <p>
    Pokud m&aacute;te podezřen&iacute;, že se va&scaron;e osobn&iacute; př&iacute;stupov&eacute;
    &uacute;daje ztr&aacute;cej&iacute;, použ&iacute;vaj&iacute; bez va&scaron;&iacute; autorizace,
    jsou odcizeny nebo jinak kompromitov&aacute;ny, mus&iacute;te n&aacute;s okamžitě kontaktovat,
    změnit heslo a přihl&aacute;sit se. Jak&eacute;koli nepřiměřen&eacute; prodlen&iacute; s
    upozorněn&iacute;m může ovlivnit bezpečnost va&scaron;eho &uacute;čtu (&uacute;čtů) a
    finančn&iacute;ch prostředků na něm držen&yacute;ch a v&eacute;st k odpovědnosti klienta za
    vznikl&eacute; finančn&iacute; ztr&aacute;ty.
  </p>
  <p>
    Nejste opr&aacute;vněni zmocnit třet&iacute; strany k př&iacute;stupu do Syst&eacute;mu a
    &Uacute;čtu (&uacute;čtů) pomoc&iacute; va&scaron;ich osobn&iacute;ch př&iacute;stupov&yacute;ch
    pověřen&iacute;, k zad&aacute;v&aacute;n&iacute; a autorizaci Objedn&aacute;vek
    va&scaron;&iacute;m jm&eacute;nem, s v&yacute;jimkou př&iacute;padu Z&aacute;stupce.
  </p>
  <p>
    Pokud se nebudete ř&iacute;dit na&scaron;imi bezpečnostn&iacute;mi pokyny, budete
    v&yacute;hradně odpovědn&iacute; za ztr&aacute;tu finančn&iacute;ch prostředků a
    dal&scaron;&iacute; ztr&aacute;ty a &scaron;kody vznikl&eacute; v důsledku
    poru&scaron;en&iacute; nebo neznalosti bezpečnostn&iacute;ch pokynů.
  </p>
  <p>POPLATKY</p>
  <p>
    Za poskytnut&eacute; Služby se Klient zavazuje platit poplatky stanoven&eacute; N&aacute;vrhem .
    Sazby poplatků z&aacute;vis&iacute; na druhu Služeb, kter&eacute; Klient využ&iacute;v&aacute;.
    Sazebn&iacute;k poplatků je k dispozici v profilu.
  </p>
  <p>
    Klient potvrzen&iacute;m těchto Podm&iacute;nek potvrzuje, že si přečetl a sezn&aacute;mil se s
    Sazebn&iacute;kem poplatků a souhlas&iacute; s nimi.
  </p>
  <p>
    Neodvolatelně souhlas&iacute;te s t&iacute;m, že jsme opr&aacute;vněni jednostranně
    zv&yacute;&scaron;it př&iacute;slu&scaron;n&eacute; poplatky s předchoz&iacute;m
    p&iacute;semn&yacute;m ozn&aacute;men&iacute;m:
  </p>
  <p>
    nejm&eacute;ně 60 (&scaron;edes&aacute;t) kalend&aacute;řn&iacute;ch dnů předem upozornit
    Klienta, kter&yacute; m&aacute; u n&aacute;s Osobn&iacute; &uacute;čet, a
  </p>
  <p>
    nejm&eacute;ně 30 (třicet) kalend&aacute;řn&iacute;ch dnů předem upozornit Klienta, kter&yacute;
    m&aacute; u n&aacute;s Obchodn&iacute; &uacute;čet.
  </p>
  <p>
    Pokud nesouhlas&iacute;te s nově stanoven&yacute;mi poplatky, můžete ukončit Obchodn&iacute;
    vztah a poskytov&aacute;n&iacute; Služeb a uzavř&iacute;t svůj &Uacute;čet (&uacute;čty) v
    n&iacute;že uveden&eacute;m pořad&iacute;.
  </p>
  <p>
    Jsme opr&aacute;vněni dle vlastn&iacute;ho uv&aacute;žen&iacute; sn&iacute;žit poplatky nebo
    zru&scaron;it poplatky bez předchoz&iacute; oznamovac&iacute; povinnosti.
  </p>
  <p>
    Měli byste pravidelně nav&scaron;těvovat na&scaron;i webovou str&aacute;nku, aplikaci a svůj
    profil, abyste mohli sledovat jak&eacute;koli novinky a změny t&yacute;kaj&iacute;c&iacute; se
    sazebn&iacute;ku poplatků a poskytovan&yacute;ch služeb.
  </p>
  <p>
    Vyhrazujeme si pr&aacute;vo podle vlastn&iacute;ho uv&aacute;žen&iacute; uplatnit
    individu&aacute;ln&iacute; poplatky, kter&eacute; se mohou li&scaron;it od standardn&iacute;ho
    sazebn&iacute;ku poplatků. Jednotliv&eacute; sazby poplatků budou stanoveny na z&aacute;kladě
    n&aacute;mi stanoven&yacute;ch přiměřen&yacute;ch a opr&aacute;vněn&yacute;ch důvodů a v
    z&aacute;vislosti na konkr&eacute;tn&iacute;ch Služb&aacute;ch využ&iacute;van&yacute;ch
    Klientem. Klient bude předem informov&aacute;n prostřednictv&iacute;m Profilu o v&scaron;ech
    individu&aacute;ln&iacute;ch sazb&aacute;ch poplatků vztahuj&iacute;c&iacute;ch se na Klienta.
    Nesouhlas&iacute;-li Klient s jednotliv&yacute;mi sazbami poplatků, je opr&aacute;vněn
    neuž&iacute;vat Služby, u kter&yacute;ch jsou stanoveny individu&aacute;ln&iacute; sazby
    poplatků, nebo ukončit Obchodn&iacute; vztah a zru&scaron;it &Uacute;čet (&uacute;čty).
    Standardn&iacute; sazebn&iacute;k poplatků se vztahuje na ty Služby, kter&eacute; nejsou hrazeny
    jednotliv&yacute;mi poplatky.
  </p>
  <p>
    Klient neodvolatelně souhlas&iacute; a potvrzuje, že poplatek za otevřen&iacute; &uacute;čtu a
    poplatek za veden&iacute; &uacute;čtu, pokud existuje, jsou hrazeny předem a nejsou
    vratn&eacute;.
  </p>
  <p>
    Poplatky by měly b&yacute;t splatn&eacute; v měně &Uacute;čtu a budou automaticky odečteny z
    &Uacute;čtu bez va&scaron;eho předchoz&iacute;ho upozorněn&iacute; a souhlasu. Pokud se měna
    &uacute;čtu li&scaron;&iacute; od měny poplatku, je Draph opr&aacute;vněn použ&iacute;t směnu
    měny podle směnn&yacute;ch kurzů stanoven&yacute;ch Draph a platn&yacute;ch v okamžiku směny
    měn. Poplatek za směnu měny bude odečten z &uacute;čtu.
  </p>
  <p>
    Pokud u n&aacute;s m&aacute;te několik &Uacute;čtů, vyhrazujeme si pr&aacute;vo odeč&iacute;st
    poplatky z jak&eacute;hokoli &Uacute;čtu s dostatečn&yacute;m zůstatkem na &Uacute;čtu.
  </p>
  <p>
    Je-li poplatek vyj&aacute;dřen v procentech, vyhrazujeme si pr&aacute;vo uplatnit
    konkr&eacute;tn&iacute; poplatek až do nejvy&scaron;&scaron;&iacute;ho určen&eacute;ho rozsahu a
    naopak, bez dodatečn&eacute;ho upozorněn&iacute; Klienta. V&scaron;echny odečten&eacute;
    poplatky se prom&iacute;tnou do v&yacute;pisu z &Uacute;čtu, kter&yacute; je zdarma k dispozici
    v Profilu.
  </p>
  <p>UKONČEN&Iacute; SLUŽEB A UZAVŘEN&Iacute; &Uacute;ČTU</p>
  <p>
    Na&scaron;i spolupr&aacute;ci a poskytov&aacute;n&iacute; Služeb můžete kdykoli ukončit
    t&iacute;m, že n&aacute;m to ozn&aacute;m&iacute;te.
  </p>
  <p>
    Ukončen&iacute;m Obchodn&iacute;ho vztahu nav&aacute;zan&eacute;ho mezi n&aacute;mi
    pozastav&iacute;me poskytov&aacute;n&iacute; v&scaron;ech Služeb, uzavřeme v&scaron;echny
    va&scaron;e &Uacute;čty a zru&scaron;&iacute;me v&aacute;&scaron; př&iacute;stup do
    Syst&eacute;mu a Aplikace.
  </p>
  <p>
    Mus&iacute;te zajistit, že k datu ukončen&iacute; obchodn&iacute;ho vztahu budou va&scaron;e
    z&aacute;vazky vůči n&aacute;m plně splněny (včetně, nikoli v&scaron;ak v&yacute;hradně,
    jak&yacute;chkoli poplatků a poplatků splatn&yacute;ch a splatn&yacute;ch podle sazebn&iacute;ku
    poplatků nebo jin&yacute;ch dohod mezi v&aacute;mi a n&aacute;mi v souvislosti s
    poskytovan&yacute;mi službami, jakož i jak&yacute;chkoli sankc&iacute;, &scaron;kod,
    ztr&aacute;t a jin&yacute;ch č&aacute;stek, kter&eacute; jsme utrpěli nebo zaplatili
    třet&iacute;m stran&aacute;m vinou klienta).
  </p>
  <p>
    Mus&iacute;te zajistit dostatečn&yacute; zůstatek na &Uacute;čtu (&uacute;čtech) ke dni
    ukončen&iacute; spolupr&aacute;ce, aby pokryl v&scaron;echny poplatky splatn&eacute; a
    splatn&eacute; n&aacute;m za služby poskytovan&eacute; v souladu se Sazebn&iacute;kem poplatků
    nebo jin&yacute;mi dohodami uzavřen&yacute;mi mezi v&aacute;mi a n&aacute;mi. Na&scaron;e
    poplatky budou &uacute;čtov&aacute;ny poměrně.
  </p>
  <p>
    Zajist&iacute;te, aby k datu ukončen&iacute; spolupr&aacute;ce nebyly na &Uacute;čtu
    (&uacute;čtech) ž&aacute;dn&eacute; finančn&iacute; prostředky, s v&yacute;jimkou těch,
    kter&eacute; jsou nezbytn&eacute; k zaplacen&iacute; př&iacute;padn&yacute;ch
    nezaplacen&yacute;ch poplatků nebo poplatků.
  </p>
  <p>
    Nebudeme moci ukončit na&scaron;i spolupr&aacute;ci a uzavř&iacute;t &uacute;čet (&uacute;čty),
    pokud jsou na &uacute;čtu (&uacute;čtech) finančn&iacute; prostředky.
  </p>
  <p>
    Nebudeme moci ukončit na&scaron;i spolupr&aacute;ci, pokud k datu ukončen&iacute; budou vůči
    n&aacute;m nějak&eacute; nesplacen&eacute; z&aacute;vazky jak&eacute;koli povahy, včetně
    jak&yacute;chkoli neuhrazen&yacute;ch poplatků a poplatků.
  </p>
  <p>
    Když obdrž&iacute;te potvrzen&iacute; o uzavřen&iacute; &Uacute;čtu (&uacute;čtů), již nebudete
    m&iacute;t př&iacute;stup k profilu a &uacute;čtu (&uacute;čtů).
  </p>
  <p>
    Nemůžete ukončit na&scaron;i spolupr&aacute;ci a uzavř&iacute;t &uacute;čet (&uacute;čty) v
    př&iacute;padě jak&eacute;hokoli vy&scaron;etřov&aacute;n&iacute; podvodu, pran&iacute;
    &scaron;pinav&yacute;ch peněz, zadlužen&iacute; a podobně, kter&eacute; prov&aacute;d&iacute;me
    my nebo jak&yacute;koli př&iacute;slu&scaron;n&yacute; org&aacute;n. Vyhrazujeme si pr&aacute;vo
    &bdquo;zmrazit&ldquo; va&scaron;e finančn&iacute; prostředky a pozastavit
    poskytov&aacute;n&iacute; Služeb, dokud nebude vy&scaron;etřov&aacute;n&iacute; zcela dokončeno.
  </p>
  <p>
    Jsme opr&aacute;vněni okamžitě ukončit poskytov&aacute;n&iacute; Služeb a uzavř&iacute;t
    &Uacute;čet(y), pokud se důvodně domn&iacute;v&aacute;me, že:
  </p>
  <p>
    poru&scaron;&iacute;te jak&yacute;koli z&aacute;vazek a z&aacute;ruku zde uvedenou a
    takov&eacute; poru&scaron;en&iacute; nelze napravit nebo nebylo napraveno v n&aacute;mi
    stanoven&eacute;m časov&eacute;m r&aacute;mci,
  </p>
  <p>
    nedokonč&iacute;te nezbytn&eacute; kontroly totožnosti a postupy KYC nebo nepředlož&iacute;te
    n&aacute;mi požadovan&eacute; informace pro (a) &uacute;čely AML/CTF; (b) jin&eacute;
    pr&aacute;vn&iacute; &uacute;čely přiměřeně nezbytn&eacute; k poskytov&aacute;n&iacute; Služeb;
    (c) chr&aacute;nit na&scaron;e opr&aacute;vněn&eacute; z&aacute;jmy; nebo (d) v&aacute;mi
    poskytnut&eacute; informace neodpov&iacute;daj&iacute; požadavkům stanoven&yacute;m
    platn&yacute;mi z&aacute;kony a předpisy nebo vzniknou pochybnosti o pravdivosti a pravosti
    předložen&yacute;ch dokumentů,
  </p>
  <p>
    se dozv&iacute;me ze spolehliv&eacute;ho zdroje nebo m&aacute;me důvod se domn&iacute;vat, že
    jste zapojeni do jak&eacute;koli podvodn&eacute; činnosti, pran&iacute; &scaron;pinav&yacute;ch
    peněz, financov&aacute;n&iacute; terorismu nebo jin&eacute; trestn&eacute; činnosti,
  </p>
  <p>
    m&aacute;me důvodn&eacute; podezřen&iacute;, že &Uacute;čty byly nebo jsou
    použ&iacute;v&aacute;ny bez va&scaron;eho svolen&iacute; nebo podvodně použity třet&iacute;mi
    osobami,
  </p>
  <p>se dozv&iacute; o zadlužen&iacute; klienta, jeho &uacute;padku nebo likvidaci,</p>
  <p>
    měli bychom ukončit poskytov&aacute;n&iacute; Služeb a uzavř&iacute;t &Uacute;čet (&uacute;čty)
    z důvodu z&aacute;vazn&yacute;ch regulačn&iacute;ch požadavků,
  </p>
  <p>
    druh obchodn&iacute; činnosti/povol&aacute;n&iacute; nebo transakčn&iacute; činnosti Klienta
    m&aacute; nebo může m&iacute;t potenci&aacute;lně po&scaron;kodit na&scaron;i finančn&iacute;
    stabilitu nebo pověst, nebo může po&scaron;kodit opr&aacute;vněn&eacute; z&aacute;jmy
    jin&yacute;ch klientů, třet&iacute;ch osob a finančn&iacute;ho trhu jako celku.
  </p>
  <p>
    O na&scaron;em rozhodnut&iacute; ukončit na&scaron;i spolupr&aacute;ci a zavř&iacute;t
    &uacute;čet (&uacute;čty) v&aacute;s budeme informovat, jakmile to bude rozumně
    provediteln&eacute;, zasl&aacute;n&iacute;m př&iacute;slu&scaron;n&eacute;ho
    ozn&aacute;men&iacute; prostřednictv&iacute;m Syst&eacute;mu s pokyny ohledně finančn&iacute;ch
    prostředků držen&yacute;ch na v&yacute;běru z &uacute;čtu (&uacute;čtů), s v&yacute;jimkou
    př&iacute;padů, kdy by poskytnut&iacute; takov&eacute;ho ozn&aacute;men&iacute; oslabilo
    bezpečnostn&iacute; opatřen&iacute; nebo je zak&aacute;z&aacute;no
    př&iacute;slu&scaron;n&yacute;m z&aacute;konem.
  </p>
  <p>
    Vyhrazujeme si pr&aacute;vo ukončit na&scaron;i spolupr&aacute;ci a uzavř&iacute;t &uacute;čet
    (&uacute;čty), pokud služby nepouž&iacute;v&aacute;te a v&aacute;&scaron; &uacute;čet je
    neaktivn&iacute; po dobu del&scaron;&iacute; než n&aacute;sleduj&iacute;c&iacute;ch 6
    (&scaron;esti) měs&iacute;ců. Př&iacute;slu&scaron;n&aacute; v&yacute;pověď
    prostřednictv&iacute;m Syst&eacute;mu v&aacute;m bude zasl&aacute;na 2 (dva) měs&iacute;ce
    předem. Pož&aacute;d&aacute;me v&aacute;s o v&yacute;běr prostředků na &Uacute;čtu v
    přiměřen&eacute; lhůtě, po kterou bude &Uacute;čet př&iacute;stupn&yacute; pouze pro
    v&yacute;běr zb&yacute;vaj&iacute;c&iacute;ho zůstatku. Aby se přede&scaron;lo pochybnostem,
    sr&aacute;žka poplatků, plateb nebo jin&yacute;ch plateb splatn&yacute;ch a splatn&yacute;ch
    n&aacute;m podle těchto Podm&iacute;nek nebude považov&aacute;na za Platebn&iacute; transakci
    nebo činnost na &Uacute;čtu.
  </p>
  <p>
    Pokud je v den ukončen&iacute; spolupr&aacute;ce na &Uacute;čtu st&aacute;le zůstatek po
    odečten&iacute; v&scaron;ech poplatků, poplatků a jin&yacute;ch spravedliv&yacute;ch plateb,
    vyhrazujeme si pr&aacute;vo &uacute;čet uzavř&iacute;t a zb&yacute;vaj&iacute;c&iacute; zůstatek
    zablokovat. Ve&scaron;ker&eacute; zb&yacute;vaj&iacute;c&iacute; prostředky ze
    zru&scaron;en&eacute;ho &uacute;čtu budete moci vybrat pouze tak, že n&aacute;s kontaktujete a
    pož&aacute;d&aacute;te o převod prostředků ze zru&scaron;en&eacute;ho &uacute;čtu. Dokud jsou u
    n&aacute;s takov&eacute; prostředky uloženy, nez&iacute;sk&aacute;me ž&aacute;dn&yacute;
    &uacute;rok. Za takov&yacute; pozdn&iacute; v&yacute;běr prostředků může b&yacute;t
    &uacute;čtov&aacute;n dodatečn&yacute; poplatek.
  </p>
  <p>
    Aniž jsou dotčena ostatn&iacute; ustanoven&iacute; t&eacute;to smlouvy, v př&iacute;padě
    ukončen&iacute; Obchodn&iacute;ho vztahu a zru&scaron;en&iacute; &Uacute;čtu z jak&eacute;hokoli
    důvodu se Klientovi nevrac&iacute; ž&aacute;dn&eacute; již zaplacen&eacute; nebo předem
    zaplacen&eacute; poplatky za zř&iacute;zen&iacute; &Uacute;čtu a poskytnut&eacute; Služby.
  </p>
  <p>
    Garantujeme uložen&iacute; dat Klienta, včetně historie transakc&iacute;, po dobu
    minim&aacute;lně 10 (deseti) let od ukončen&iacute; Obchodn&iacute;ho vztahu a uzavřen&iacute;
    &Uacute;čtu (&uacute;čtů). Pokud potřebujete z&iacute;skat př&iacute;stup ke sv&yacute;m
    &uacute;dajům po ukončen&iacute; na&scaron;&iacute; spolupr&aacute;ce, mus&iacute;te n&aacute;s
    kontaktovat. Bude provedeno ověřen&iacute; totožnosti klienta. Pokud bude Klient
    &uacute;spě&scaron;ně identifikov&aacute;n, bude Klientovi udělen omezen&yacute; př&iacute;stup
    do Syst&eacute;mu s možnost&iacute; &bdquo;pouze pro čten&iacute;&ldquo; a Klient bude moci
    kontrolovat data uložen&aacute; u n&aacute;s, vytv&aacute;řet a stahovat v&yacute;pisy z
    &Uacute;čtu. Může b&yacute;t &uacute;čtov&aacute;n poplatek za opakovanou identifikaci Klienta a
    př&iacute;stup k obnoven&iacute; Syst&eacute;mu. Vyhrazujeme si pr&aacute;vo uplatnit na klienta
    &uacute;pln&yacute; postup KYC, pokud to přiměřeně považujeme za nutn&eacute;.
  </p>
  <p>OSOBN&Iacute; &Uacute;DAJE A DŮVĚRNOST</p>
  <p>
    Zpracov&aacute;n&iacute; va&scaron;ich osobn&iacute;ch &uacute;dajů se ř&iacute;d&iacute;
    na&scaron;imi Z&aacute;sadami ochrany osobn&iacute;ch &uacute;dajů, kter&eacute; jsou k
    dispozici na webov&yacute;ch str&aacute;nk&aacute;ch.
  </p>
  <p>
    Budeme použ&iacute;vat a zpracov&aacute;vat Osobn&iacute; &uacute;daje shrom&aacute;žděn&eacute;
    a uchov&aacute;van&eacute; u n&aacute;s, poskytnut&eacute; va&scaron;imi nebo třet&iacute;mi
    stranami, zejm&eacute;na k plněn&iacute; na&scaron;ich z&aacute;vazků při
    poskytov&aacute;n&iacute; Služeb, zaji&scaron;těn&iacute; kvalitativn&iacute;ch Služeb, k
    plněn&iacute; na&scaron;ich regulačn&iacute;ch povinnost&iacute; a ochraně
    opr&aacute;vněn&yacute;ch z&aacute;jmů. &Uacute;čely a pr&aacute;vn&iacute; důvody
    zpracov&aacute;n&iacute; osobn&iacute;ch &uacute;dajů jsou podrobně pops&aacute;ny v
    na&scaron;ich Z&aacute;sad&aacute;ch ochrany osobn&iacute;ch &uacute;dajů dostupn&yacute;ch na
    webov&yacute;ch str&aacute;nk&aacute;ch.
  </p>
  <p>
    Než s n&aacute;mi nav&aacute;žete obchodn&iacute; vztah, měli byste si pozorně přeč&iacute;st
    na&scaron;e Z&aacute;sady ochrany osobn&iacute;ch &uacute;dajů.
  </p>
  <p>
    Přihl&aacute;&scaron;kou do na&scaron;ich Služeb a registrac&iacute; v Syst&eacute;mu
    potvrzujete, že jste se sezn&aacute;mili se Z&aacute;sadami ochrany osobn&iacute;ch
    &uacute;dajů.
  </p>
  <p>
    V na&scaron;em každodenn&iacute;m provozu př&iacute;sně dodržujeme a dodržujeme podm&iacute;nky
    Z&aacute;sad ochrany osobn&iacute;ch &uacute;dajů, Z&aacute;kona a GDPR. Zaručujeme bezpečnost
    va&scaron;ich osobn&iacute;ch &uacute;dajů, kter&eacute; m&aacute;me k dispozici, a
    z&aacute;konn&eacute; zpracov&aacute;n&iacute; va&scaron;ich osobn&iacute;ch &uacute;dajů.
    Zaručujeme, že Osobn&iacute; &uacute;daje budou použity v minim&aacute;ln&iacute;m rozsahu
    nezbytn&eacute;m k plněn&iacute; na&scaron;ich smluvn&iacute;ch a/nebo regulačn&iacute;ch
    povinnost&iacute; stanoven&yacute;ch v tomto dokumentu a jak&yacute;chkoli dodatc&iacute;ch v
    tomto dokumentu.
  </p>
  <p>
    Souhlas&iacute;te s t&iacute;m, že společnost Draph může přev&eacute;st va&scaron;e
    osobn&iacute; &uacute;daje, z&aacute;stupce, ředitele, akcion&aacute;ře, skutečn&eacute;
    vlastn&iacute;ky atd., pokud existuj&iacute;, partnerům (zpracovatelům dat), bank&aacute;m,
    jin&yacute;m poskytovatelům platebn&iacute;ch služeb a dal&scaron;&iacute;m třet&iacute;m
    stran&aacute;m za &uacute;čelem zaji&scaron;těn&iacute; poskytov&aacute;n&iacute; Služeb a
    prov&aacute;děn&iacute; Př&iacute;kazů a splněn&iacute; na&scaron;ich regulačn&iacute;ch
    povinnost&iacute;.
  </p>
  <p>
    Souhlasem s těmito Podm&iacute;nkami n&aacute;m udělujete neodvolateln&eacute; a
    bezpodm&iacute;nečn&eacute; pr&aacute;vo spolupracovat s poskytovateli služeb třet&iacute;ch
    stran, včetně, ale nejen, zas&iacute;l&aacute;n&iacute; ž&aacute;dost&iacute; a kontroly
    různ&yacute;ch datab&aacute;z&iacute;, za &uacute;čelem ověřen&iacute; identity klienta a
    přesnosti dal&scaron;&iacute;ch &uacute;dajů a dokumentů předložen&yacute;ch klientem pro
    &uacute;čely KYC a s c&iacute;lem splnit regulačn&iacute; požadavky z&aacute;vazn&eacute; pro
    n&aacute;s a chr&aacute;nit na&scaron;e pr&aacute;vn&iacute; z&aacute;jmy.
  </p>
  <p>
    Pokud maj&iacute; b&yacute;t va&scaron;e osobn&iacute; &uacute;daje před&aacute;ny mimo Českou
    republiku nebo oblast Evropsk&eacute; unie do třet&iacute;ch zem&iacute;, z&iacute;sk&aacute;me
    nejprve v&aacute;&scaron; v&yacute;slovn&yacute; souhlas a zajist&iacute;me
    ve&scaron;ker&aacute; bezpečnostn&iacute; opatřen&iacute; uplatňovan&aacute; při přenosu a
    uchov&aacute;v&aacute;n&iacute; va&scaron;ich &uacute;dajů a seznam třet&iacute;ch zem&iacute; a
    poskytovatelů služeb třet&iacute;ch stran, kter&yacute;m budou va&scaron;e osobn&iacute;
    &uacute;daje před&aacute;ny.
  </p>
  <p>
    Strany se zavazuj&iacute; vz&aacute;jemně chr&aacute;nit sv&eacute; technologick&eacute; a
    obchodn&iacute; informace, o kter&yacute;ch se dozvěděly.
  </p>
  <p>
    Klient se zavazuje nezveřejňovat a chr&aacute;nit na&scaron;e technologick&eacute; a
    obchodn&iacute; informace před neopr&aacute;vněn&yacute;m zpř&iacute;stupněn&iacute;m
    třet&iacute;m osob&aacute;m bez povolen&eacute;ho &uacute;čelu. V každ&eacute;m př&iacute;padě,
    kdy m&aacute; klient v &uacute;myslu nebo je povinen sdělit jak&eacute;koli důvěrn&eacute;
    informace t&yacute;kaj&iacute;c&iacute; se služby Draph a/nebo poskytovan&yacute;ch služeb,
    n&aacute;s o tom předem informuje. V př&iacute;padě, že předchoz&iacute; ozn&aacute;men&iacute;
    nen&iacute; možn&eacute;, bude n&aacute;s Klient co nejdř&iacute;ve informovat.
  </p>
  <p>DODATKY K PODM&Iacute;NK&Aacute;M</p>
  <p>Jsme opr&aacute;vněni jednostranně změnit tyto Podm&iacute;nky.</p>
  <p>
    Předt&iacute;m, než jak&eacute;koli změny (včetně dodatků) těchto Podm&iacute;nek nebo
    jak&eacute;hokoli jin&eacute;ho dokumentu, na kter&yacute; se v nich odvol&aacute;v&aacute;me,
    vstoup&iacute; v platnost, v&aacute;s budeme předem informovat. Ozn&aacute;men&iacute; bude
    zasl&aacute;no prostřednictv&iacute;m syst&eacute;mu:
  </p>
  <p>
    pro Klienta s Osobn&iacute;m &uacute;čtem - 60 (&scaron;edes&aacute;t)
    kalend&aacute;řn&iacute;ch dnů předem,
  </p>
  <p>
    pro Klienta s Podnikatelsk&yacute;m &uacute;čtem - 30 (třicet) kalend&aacute;řn&iacute;ch dnů
    předem.
  </p>
  <p>
    Pokud s jak&yacute;mikoli změnami nesouhlas&iacute;te, můžete ve v&yacute;&scaron;e
    uveden&eacute; lhůtě pro ozn&aacute;men&iacute; změn ukončit Obchodn&iacute; vztah
    zasl&aacute;n&iacute;m př&iacute;slu&scaron;n&eacute;ho ozn&aacute;men&iacute;
    prostřednictv&iacute;m Syst&eacute;mu.
  </p>
  <p>
    Pokud Klient ve lhůtě pro ozn&aacute;men&iacute; změn nevznese n&aacute;mitky proti
    proveden&yacute;m změn&aacute;m, m&aacute; se za to, že s nimi souhlas&iacute;te a
    přij&iacute;m&aacute;te je jako z&aacute;vazn&eacute; ode dne &uacute;činnosti změn.
  </p>
  <p>
    Jsme opr&aacute;vněni jednostranně změnit tyto Podm&iacute;nky s okamžitou
    &uacute;činnost&iacute; v př&iacute;padě změn z&aacute;konů a předpisů, kter&eacute; se na
    n&aacute;s z&aacute;vazně vztahuj&iacute; nebo upravuj&iacute;c&iacute;ch
    poskytov&aacute;n&iacute; Služeb a vyžaduj&iacute;, aby byly změny provedeny s okamžitou
    &uacute;činnost&iacute;.
  </p>
  <p>
    Můžete n&aacute;s pož&aacute;dat o poskytnut&iacute; n&aacute;vrhu jak&yacute;chkoli
    navrhovan&yacute;ch změn Podm&iacute;nek, Sazebn&iacute;ku poplatků, jin&eacute;ho dodatku k
    těmto Podm&iacute;nk&aacute;m nebo jak&eacute;hokoli dokumentu, na kter&yacute; se v nich
    odvol&aacute;v&aacute;me, před datem jejich &uacute;činnosti a pož&aacute;dat o
    poskytnut&iacute; př&iacute;slu&scaron;n&yacute;ch konzultac&iacute; o nov&yacute;ch nebo
    upraven&yacute;ch podm&iacute;nk&aacute;ch.
  </p>
  <p>
    Jak&eacute;koli změny, doplňky nebo dokumenty, na kter&eacute; v Podm&iacute;nk&aacute;ch
    odkazujeme, budou považov&aacute;ny za ned&iacute;lnou souč&aacute;st těchto Podm&iacute;nek a
    budou m&iacute;t stejnou pr&aacute;vn&iacute; s&iacute;lu jako Podm&iacute;nky.
  </p>
  <p>
    V&scaron;echny historick&eacute; a nov&eacute; verze Podm&iacute;nek budou dostupn&eacute; v
    Syst&eacute;mu. Povinnost&iacute; Klienta je pravidelně, alespoň jednou měs&iacute;čně,
    kontrolovat webov&eacute; str&aacute;nky a Profil, zda nejsou n&aacute;mi
    prov&aacute;děn&eacute; aktualizace.
  </p>
  <p>Nesm&iacute;te jednostranně měnit Podm&iacute;nky ani Sazebn&iacute;k poplatků.</p>
  <p>KOMUNIKACE, REKLAMACE A SPORY</p>
  <p>
    Strany budou komunikovat prostřednictv&iacute;m Syst&eacute;mu nebo e-mailu Klienta
    registrovan&eacute;ho v Syst&eacute;mu.
  </p>
  <p>
    Klient mus&iacute; vždy udržovat platnou e-mailovou adresu registrovanou u n&aacute;s a měl by
    pravidelně kontrolovat př&iacute;choz&iacute; zpr&aacute;vy v Profilu.
  </p>
  <p>
    Neneseme odpovědnost za ztr&aacute;tu nebo &scaron;kodu, kterou Klient utrp&iacute;, pokud
    Klient sv&eacute; kontakty (e-mail, mobiln&iacute; č&iacute;slo apod.) ř&aacute;dně neuvedl nebo
    je včas neaktualizoval.
  </p>
  <p>Kontaktovat n&aacute;s můžete na e-mailov&eacute; adrese support@swipez.eu.</p>
  <p>
    Jsme opr&aacute;vněni v&aacute;m zas&iacute;lat ozn&aacute;men&iacute; prostřednictv&iacute;m
    po&scaron;tovn&iacute; služby. V tomto př&iacute;padě použijeme po&scaron;tovn&iacute; adresu
    uvedenou Klientem v Syst&eacute;mu a m&aacute; se za to, že Klient obdržel
    ozn&aacute;men&iacute; do 5 (pěti) Pracovn&iacute;ch dnů od jeho odesl&aacute;n&iacute;, ledaže
    Klient skutečně obdrž&iacute; ozn&aacute;men&iacute; později a tuto skutečnost může Klient
    doložit.
  </p>
  <p>
    M&aacute; se za to, že zpr&aacute;vy (reklamace, ž&aacute;dosti nebo st&iacute;žnosti) od
    Klientů jsou doručeny dnem jejich odesl&aacute;n&iacute; n&aacute;m, pokud je tento den
    Pracovn&iacute;m dnem. Zpr&aacute;vy zaslan&eacute; mimo Pracovn&iacute; den se považuj&iacute;
    za přijat&eacute; n&aacute;sleduj&iacute;c&iacute; Pracovn&iacute; den.
  </p>
  <p>
    M&aacute;te-li jak&eacute;koli st&iacute;žnosti na poskytovan&eacute; služby, měli byste jako
    prvn&iacute; t&yacute;m z&aacute;kaznick&eacute; podpory kontaktovat na adrese support@swipez.eu
    nebo zanechat zpr&aacute;vu v profilu.
  </p>
  <p>
    Pokud probl&eacute;m nevyře&scaron;&iacute; n&aacute;&scaron; t&yacute;m
    z&aacute;kaznick&eacute; podpory ke spokojenosti klienta, m&aacute; klient pr&aacute;vo podat
    form&aacute;ln&iacute; st&iacute;žnost zasl&aacute;n&iacute;m e-mailu na adresu info@swipez.eu.
  </p>
  <p>Z&Aacute;VĚREČN&Aacute; USTANOVEN&Iacute;</p>
  <p>
    Podm&iacute;nky, jak&yacute;koli dodatek nebo jak&yacute;koli dokument, na kter&yacute; v nich
    odkazujeme, představuj&iacute; &uacute;plnou vz&aacute;jemnou dohodu mezi stranami. Pokud bude
    někter&eacute; ustanoven&iacute; Podm&iacute;nek shled&aacute;no neplatn&yacute;m nebo
    nevymahateln&yacute;m, bude považov&aacute;no za vypu&scaron;těn&eacute; a nezpůsob&iacute;
    neplatnost ostatn&iacute;ch ustanoven&iacute;.
  </p>
  <p>
    Pokud jedno nebo v&iacute;ce ustanoven&iacute; Podm&iacute;nek zanikne nebo bude za
    takov&eacute; prohl&aacute;&scaron;eno podle jak&eacute;hokoli z&aacute;kona nebo
    nař&iacute;zen&iacute; nebo na z&aacute;kladě konečn&eacute;ho rozhodnut&iacute; soudu
    př&iacute;slu&scaron;n&eacute; jurisdikce, ostatn&iacute; ustanoven&iacute; si zachovaj&iacute;
    z&aacute;vaznost a rozsah. Ustanoven&iacute;, kter&aacute; jsou považov&aacute;na za
    neplatn&aacute;, budou pot&eacute; nahrazena ustanoven&iacute;mi, kter&aacute; se co do rozsahu
    a smyslu přibližuj&iacute; těm původně dohodnut&yacute;m.
  </p>
  <p>
    Podm&iacute;nky vstoup&iacute; v platnost pot&eacute;, co s nimi Klient uděl&iacute; souhlas
    kliknut&iacute;m na z&aacute;ložku validace při registraci k otevřen&iacute; &Uacute;čtu v
    Syst&eacute;mu. Podm&iacute;nky zůst&aacute;vaj&iacute; v platnosti po dobu neurčitou, dokud
    nebudou ukončeny v souladu s ustanoven&iacute;mi zde uveden&yacute;mi.
  </p>
  <p>
    Podm&iacute;nky nemohou b&yacute;t předmětem &uacute;pln&eacute;ho nebo č&aacute;stečn&eacute;ho
    převodu ze strany Klienta, ať už za &uacute;platu nebo bezplatně. Je proto
    zak&aacute;z&aacute;no přev&aacute;dět na třet&iacute; osobu jak&aacute;koli pr&aacute;va nebo
    povinnosti, kter&eacute; Klient podle t&eacute;to smlouvy vlastn&iacute;, s v&yacute;jimkou
    Z&aacute;stupce Klienta. V př&iacute;padě poru&scaron;en&iacute; t&eacute;to podm&iacute;nky
    kromě okamžit&eacute;ho ukončen&iacute; t&eacute;to smlouvy může n&eacute;st odpovědnost Klient
    podle n&aacute;vrhu z&aacute;kona .
  </p>
  <p>
    Sv&aacute; pr&aacute;va a povinnosti vypl&yacute;vaj&iacute;c&iacute; z Podm&iacute;nek můžeme
    kdykoli postoupit jin&eacute; osobě, a to tak, že předem p&iacute;semně ozn&aacute;m&iacute;me
    klientovi:
  </p>
  <p>
    u Klienta s Osobn&iacute;m &uacute;čtem &ndash; minim&aacute;lně 60 (&scaron;edes&aacute;t)
    kalend&aacute;řn&iacute;ch dnů předem,
  </p>
  <p>
    pro Klienta s Podnikatelsk&yacute;m &uacute;čtem &ndash; minim&aacute;lně 30 (třicet)
    kalend&aacute;řn&iacute;ch dnů předem.
  </p>
  <p>
    V př&iacute;padě postoupen&iacute; nebudou va&scaron;e pr&aacute;va podle Podm&iacute;nek
    dotčena.
  </p>
  <p>
    Podm&iacute;nky se ř&iacute;d&iacute; pr&aacute;vn&iacute;m ř&aacute;dem Česk&eacute; republiky.
    Jak&yacute;koli spor vznikl&yacute; z Podm&iacute;nek nebo v souvislosti s nimi bude postoupen
    př&iacute;slu&scaron;n&eacute;mu soudu Česk&eacute; republiky.
  </p>
  <p>
    Strany potvrzuj&iacute;, že jsou opr&aacute;vněny plnit tyto Podm&iacute;nky, jsou si vědomy
    podm&iacute;nek zde stanoven&yacute;ch a smluvn&iacute;ch povinnost&iacute; Stran, jsou
    opr&aacute;vněny přeb&iacute;rat z&aacute;vazky a z&aacute;ruky zde uveden&eacute; a vstupovat
    do Obchodn&iacute;ho vztahu dobrovolně.
  </p>

  <p>Posledn&iacute; aktualizace: 01.10.2024</p>
</template>
